var map = {
	"./components/Payin/Table/ar.json": 19324,
	"./components/Payin/Table/cs.json": 31877,
	"./components/Payin/Table/de.json": 24040,
	"./components/Payin/Table/en.json": 27956,
	"./components/Payin/Table/es.json": 11571,
	"./components/Payin/Table/fr.json": 65071,
	"./components/Payin/Table/hi.json": 34608,
	"./components/Payin/Table/it.json": 81370,
	"./components/Payin/Table/kk.json": 35605,
	"./components/Payin/Table/pl.json": 62583,
	"./components/Payin/Table/pt.json": 28751,
	"./components/Payin/Table/ru.json": 30294,
	"./components/Payin/Table/uk.json": 70411,
	"./components/Payin/Table/zh.json": 59925,
	"./components/service/AMLCheck/ar.json": 43348,
	"./components/service/AMLCheck/cs.json": 15805,
	"./components/service/AMLCheck/de.json": 64160,
	"./components/service/AMLCheck/en.json": 63516,
	"./components/service/AMLCheck/es.json": 22315,
	"./components/service/AMLCheck/fr.json": 39623,
	"./components/service/AMLCheck/hi.json": 66056,
	"./components/service/AMLCheck/it.json": 38754,
	"./components/service/AMLCheck/kk.json": 17293,
	"./components/service/AMLCheck/pl.json": 86687,
	"./components/service/AMLCheck/pt.json": 42247,
	"./components/service/AMLCheck/ru.json": 12526,
	"./components/service/AMLCheck/uk.json": 89939,
	"./components/service/AMLCheck/zh.json": 64877,
	"./components/service/Comiss/ar.json": 69516,
	"./components/service/Comiss/cs.json": 6517,
	"./components/service/Comiss/de.json": 22264,
	"./components/service/Comiss/en.json": 26884,
	"./components/service/Comiss/es.json": 56067,
	"./components/service/Comiss/fr.json": 28127,
	"./components/service/Comiss/hi.json": 46848,
	"./components/service/Comiss/it.json": 48554,
	"./components/service/Comiss/kk.json": 67077,
	"./components/service/Comiss/pl.json": 61511,
	"./components/service/Comiss/pt.json": 54367,
	"./components/service/Comiss/ru.json": 88998,
	"./components/service/Comiss/uk.json": 76187,
	"./components/service/Comiss/zh.json": 40965,
	"./components/service/File/ar.json": 92208,
	"./components/service/File/cs.json": 71897,
	"./components/service/File/de.json": 15452,
	"./components/service/File/en.json": 78888,
	"./components/service/File/es.json": 48751,
	"./components/service/File/fr.json": 11835,
	"./components/service/File/hi.json": 99620,
	"./components/service/File/it.json": 39910,
	"./components/service/File/kk.json": 58777,
	"./components/service/File/pl.json": 14659,
	"./components/service/File/pt.json": 97291,
	"./components/service/File/ru.json": 72706,
	"./components/service/File/uk.json": 18247,
	"./components/service/File/zh.json": 33785,
	"./components/service/GetInputs/ar.json": 94617,
	"./components/service/GetInputs/cs.json": 14388,
	"./components/service/GetInputs/de.json": 19397,
	"./components/service/GetInputs/en.json": 98217,
	"./components/service/GetInputs/es.json": 25082,
	"./components/service/GetInputs/fr.json": 40498,
	"./components/service/GetInputs/hi.json": 61317,
	"./components/service/GetInputs/it.json": 23627,
	"./components/service/GetInputs/kk.json": 12788,
	"./components/service/GetInputs/pl.json": 49598,
	"./components/service/GetInputs/pt.json": 87814,
	"./components/service/GetInputs/ru.json": 72123,
	"./components/service/GetInputs/uk.json": 33794,
	"./components/service/GetInputs/zh.json": 52500,
	"./components/service/Header/ar.json": 37869,
	"./components/service/Header/cs.json": 760,
	"./components/service/Header/de.json": 6345,
	"./components/service/Header/en.json": 54765,
	"./components/service/Header/es.json": 60070,
	"./components/service/Header/fr.json": 42334,
	"./components/service/Header/hi.json": 12617,
	"./components/service/Header/it.json": 61287,
	"./components/service/Header/kk.json": 91624,
	"./components/service/Header/pl.json": 63402,
	"./components/service/Header/pt.json": 34498,
	"./components/service/Header/ru.json": 58151,
	"./components/service/Header/uk.json": 49646,
	"./components/service/Header/zh.json": 94056,
	"./components/service/Informator/ar.json": 41997,
	"./components/service/Informator/cs.json": 81720,
	"./components/service/Informator/de.json": 65449,
	"./components/service/Informator/en.json": 21325,
	"./components/service/Informator/es.json": 99782,
	"./components/service/Informator/fr.json": 1438,
	"./components/service/Informator/hi.json": 43593,
	"./components/service/Informator/it.json": 65415,
	"./components/service/Informator/kk.json": 91848,
	"./components/service/Informator/pl.json": 70538,
	"./components/service/Informator/pt.json": 54978,
	"./components/service/Informator/ru.json": 78631,
	"./components/service/Informator/uk.json": 39374,
	"./components/service/Informator/zh.json": 48168,
	"./components/service/Members/ar.json": 20899,
	"./components/service/Members/cs.json": 36138,
	"./components/service/Members/de.json": 4619,
	"./components/service/Members/en.json": 91875,
	"./components/service/Members/es.json": 79044,
	"./components/service/Members/fr.json": 29272,
	"./components/service/Members/hi.json": 50787,
	"./components/service/Members/it.json": 75489,
	"./components/service/Members/kk.json": 8138,
	"./components/service/Members/pl.json": 71748,
	"./components/service/Members/pt.json": 32380,
	"./components/service/Members/ru.json": 78005,
	"./components/service/Members/uk.json": 84908,
	"./components/service/Members/zh.json": 60006,
	"./components/service/PayStatusTemplate/ar.json": 50604,
	"./components/service/PayStatusTemplate/cs.json": 71253,
	"./components/service/PayStatusTemplate/de.json": 3352,
	"./components/service/PayStatusTemplate/en.json": 7972,
	"./components/service/PayStatusTemplate/es.json": 37155,
	"./components/service/PayStatusTemplate/fr.json": 92863,
	"./components/service/PayStatusTemplate/hi.json": 11584,
	"./components/service/PayStatusTemplate/it.json": 13290,
	"./components/service/PayStatusTemplate/kk.json": 31813,
	"./components/service/PayStatusTemplate/pl.json": 26247,
	"./components/service/PayStatusTemplate/pt.json": 19103,
	"./components/service/PayStatusTemplate/ru.json": 70086,
	"./components/service/PayStatusTemplate/uk.json": 57275,
	"./components/service/PayStatusTemplate/zh.json": 5701,
	"./components/service/Registration/ar.json": 28769,
	"./components/service/Registration/cs.json": 39996,
	"./components/service/Registration/de.json": 97069,
	"./components/service/Registration/en.json": 35041,
	"./components/service/Registration/es.json": 49698,
	"./components/service/Registration/fr.json": 37050,
	"./components/service/Registration/hi.json": 34093,
	"./components/service/Registration/it.json": 17123,
	"./components/service/Registration/kk.json": 43772,
	"./components/service/Registration/pl.json": 9686,
	"./components/service/Registration/pt.json": 69326,
	"./components/service/Registration/ru.json": 13987,
	"./components/service/Registration/uk.json": 12090,
	"./components/service/Registration/zh.json": 19484,
	"./components/service/SafetyRes/ar.json": 52082,
	"./components/service/SafetyRes/cs.json": 12967,
	"./components/service/SafetyRes/de.json": 36634,
	"./components/service/SafetyRes/en.json": 47762,
	"./components/service/SafetyRes/es.json": 94321,
	"./components/service/SafetyRes/fr.json": 6201,
	"./components/service/SafetyRes/hi.json": 42770,
	"./components/service/SafetyRes/it.json": 68532,
	"./components/service/SafetyRes/kk.json": 86567,
	"./components/service/SafetyRes/pl.json": 74129,
	"./components/service/SafetyRes/pt.json": 24649,
	"./components/service/SafetyRes/ru.json": 55316,
	"./components/service/SafetyRes/uk.json": 16761,
	"./components/service/SafetyRes/zh.json": 57403,
	"./components/service/SidePanel/ar.json": 9443,
	"./components/service/SidePanel/cs.json": 83562,
	"./components/service/SidePanel/de.json": 19467,
	"./components/service/SidePanel/en.json": 49795,
	"./components/service/SidePanel/es.json": 47812,
	"./components/service/SidePanel/fr.json": 26296,
	"./components/service/SidePanel/hi.json": 45859,
	"./components/service/SidePanel/it.json": 21089,
	"./components/service/SidePanel/kk.json": 19978,
	"./components/service/SidePanel/pl.json": 83172,
	"./components/service/SidePanel/pt.json": 94204,
	"./components/service/SidePanel/ru.json": 96757,
	"./components/service/SidePanel/uk.json": 66124,
	"./components/service/SidePanel/zh.json": 64358,
	"./components/service/StoreCard/ar.json": 84899,
	"./components/service/StoreCard/cs.json": 16490,
	"./components/service/StoreCard/de.json": 84971,
	"./components/service/StoreCard/en.json": 72227,
	"./components/service/StoreCard/es.json": 43044,
	"./components/service/StoreCard/fr.json": 9624,
	"./components/service/StoreCard/hi.json": 31139,
	"./components/service/StoreCard/it.json": 55841,
	"./components/service/StoreCard/kk.json": 88490,
	"./components/service/StoreCard/pl.json": 52100,
	"./components/service/StoreCard/pt.json": 12732,
	"./components/service/StoreCard/ru.json": 58357,
	"./components/service/StoreCard/uk.json": 65260,
	"./components/service/StoreCard/zh.json": 40358,
	"./components/service/TableList/ar.json": 2014,
	"./components/service/TableList/cs.json": 67059,
	"./components/service/TableList/de.json": 13654,
	"./components/service/TableList/en.json": 9806,
	"./components/service/TableList/es.json": 33317,
	"./components/service/TableList/fr.json": 81197,
	"./components/service/TableList/hi.json": 13326,
	"./components/service/TableList/it.json": 75928,
	"./components/service/TableList/kk.json": 50803,
	"./components/service/TableList/pl.json": 277,
	"./components/service/TableList/pt.json": 3693,
	"./components/service/TableList/ru.json": 13832,
	"./components/service/TableList/uk.json": 75053,
	"./components/service/TableList/zh.json": 55943,
	"./components/service/ZentrolinkFooter/ar.json": 23343,
	"./components/service/ZentrolinkFooter/cs.json": 85350,
	"./components/service/ZentrolinkFooter/de.json": 88807,
	"./components/service/ZentrolinkFooter/en.json": 48255,
	"./components/service/ZentrolinkFooter/es.json": 35096,
	"./components/service/ZentrolinkFooter/fr.json": 69084,
	"./components/service/ZentrolinkFooter/hi.json": 92895,
	"./components/service/ZentrolinkFooter/it.json": 99429,
	"./components/service/ZentrolinkFooter/kk.json": 48598,
	"./components/service/ZentrolinkFooter/pl.json": 72264,
	"./components/service/ZentrolinkFooter/pt.json": 72864,
	"./components/service/ZentrolinkFooter/ru.json": 40073,
	"./components/service/ZentrolinkFooter/uk.json": 36032,
	"./components/service/ZentrolinkFooter/zh.json": 26322,
	"./components/service/modal/Address/ar.json": 71516,
	"./components/service/modal/Address/cs.json": 67717,
	"./components/service/modal/Address/de.json": 59880,
	"./components/service/modal/Address/en.json": 80148,
	"./components/service/modal/Address/es.json": 47411,
	"./components/service/modal/Address/fr.json": 911,
	"./components/service/modal/Address/hi.json": 86800,
	"./components/service/modal/Address/it.json": 17210,
	"./components/service/modal/Address/kk.json": 71445,
	"./components/service/modal/Address/pl.json": 98423,
	"./components/service/modal/Address/pt.json": 80943,
	"./components/service/modal/Address/ru.json": 82486,
	"./components/service/modal/Address/uk.json": 22603,
	"./components/service/modal/Address/zh.json": 95765,
	"./components/service/modal/Answer/ar.json": 93382,
	"./components/service/modal/Answer/cs.json": 3419,
	"./components/service/modal/Answer/de.json": 46174,
	"./components/service/modal/Answer/en.json": 33286,
	"./components/service/modal/Answer/es.json": 54829,
	"./components/service/modal/Answer/fr.json": 99477,
	"./components/service/modal/Answer/hi.json": 16918,
	"./components/service/modal/Answer/it.json": 45680,
	"./components/service/modal/Answer/kk.json": 82363,
	"./components/service/modal/Answer/pl.json": 48685,
	"./components/service/modal/Answer/pt.json": 78901,
	"./components/service/modal/Answer/ru.json": 63120,
	"./components/service/modal/Answer/uk.json": 73253,
	"./components/service/modal/Answer/zh.json": 30287,
	"./components/service/modal/AssetDetails/ar.json": 49086,
	"./components/service/modal/AssetDetails/cs.json": 14131,
	"./components/service/modal/AssetDetails/de.json": 60726,
	"./components/service/modal/AssetDetails/en.json": 73230,
	"./components/service/modal/AssetDetails/es.json": 80389,
	"./components/service/modal/AssetDetails/fr.json": 28269,
	"./components/service/modal/AssetDetails/hi.json": 60398,
	"./components/service/modal/AssetDetails/it.json": 23000,
	"./components/service/modal/AssetDetails/kk.json": 14227,
	"./components/service/modal/AssetDetails/pl.json": 63701,
	"./components/service/modal/AssetDetails/pt.json": 50765,
	"./components/service/modal/AssetDetails/ru.json": 60904,
	"./components/service/modal/AssetDetails/uk.json": 22125,
	"./components/service/modal/AssetDetails/zh.json": 3015,
	"./components/service/modal/AssetsFilter/ar.json": 16201,
	"./components/service/modal/AssetsFilter/cs.json": 88196,
	"./components/service/modal/AssetsFilter/de.json": 69237,
	"./components/service/modal/AssetsFilter/en.json": 82585,
	"./components/service/modal/AssetsFilter/es.json": 11946,
	"./components/service/modal/AssetsFilter/fr.json": 25026,
	"./components/service/modal/AssetsFilter/hi.json": 98549,
	"./components/service/modal/AssetsFilter/it.json": 71387,
	"./components/service/modal/AssetsFilter/kk.json": 84420,
	"./components/service/modal/AssetsFilter/pl.json": 44910,
	"./components/service/modal/AssetsFilter/pt.json": 85270,
	"./components/service/modal/AssetsFilter/ru.json": 91051,
	"./components/service/modal/AssetsFilter/uk.json": 32978,
	"./components/service/modal/AssetsFilter/zh.json": 4503,
	"./components/service/modal/BurnEmission/ar.json": 81646,
	"./components/service/modal/BurnEmission/cs.json": 6403,
	"./components/service/modal/BurnEmission/de.json": 34630,
	"./components/service/modal/BurnEmission/en.json": 30750,
	"./components/service/modal/BurnEmission/es.json": 37397,
	"./components/service/modal/BurnEmission/fr.json": 13693,
	"./components/service/modal/BurnEmission/hi.json": 5854,
	"./components/service/modal/BurnEmission/it.json": 90152,
	"./components/service/modal/BurnEmission/kk.json": 10179,
	"./components/service/modal/BurnEmission/pl.json": 58501,
	"./components/service/modal/BurnEmission/pt.json": 76189,
	"./components/service/modal/BurnEmission/ru.json": 55576,
	"./components/service/modal/BurnEmission/uk.json": 29,
	"./components/service/modal/BurnEmission/zh.json": 32375,
	"./components/service/modal/Confirm/ar.json": 28700,
	"./components/service/modal/Confirm/cs.json": 94277,
	"./components/service/modal/Confirm/de.json": 36456,
	"./components/service/modal/Confirm/en.json": 60628,
	"./components/service/modal/Confirm/es.json": 11667,
	"./components/service/modal/Confirm/fr.json": 623,
	"./components/service/modal/Confirm/hi.json": 81680,
	"./components/service/modal/Confirm/it.json": 43770,
	"./components/service/modal/Confirm/kk.json": 48021,
	"./components/service/modal/Confirm/pl.json": 94231,
	"./components/service/modal/Confirm/pt.json": 71919,
	"./components/service/modal/Confirm/ru.json": 58518,
	"./components/service/modal/Confirm/uk.json": 94187,
	"./components/service/modal/Confirm/zh.json": 76245,
	"./components/service/modal/ConfirmCode/en.json": 74703,
	"./components/service/modal/ConfirmCode/ru.json": 97209,
	"./components/service/modal/DeleteKeyt/ar.json": 76474,
	"./components/service/modal/DeleteKeyt/cs.json": 49423,
	"./components/service/modal/DeleteKeyt/de.json": 76386,
	"./components/service/modal/DeleteKeyt/en.json": 46410,
	"./components/service/modal/DeleteKeyt/es.json": 75929,
	"./components/service/modal/DeleteKeyt/fr.json": 96321,
	"./components/service/modal/DeleteKeyt/hi.json": 8890,
	"./components/service/modal/DeleteKeyt/it.json": 20076,
	"./components/service/modal/DeleteKeyt/kk.json": 53199,
	"./components/service/modal/DeleteKeyt/pl.json": 88329,
	"./components/service/modal/DeleteKeyt/pt.json": 32145,
	"./components/service/modal/DeleteKeyt/ru.json": 28828,
	"./components/service/modal/DeleteKeyt/uk.json": 14129,
	"./components/service/modal/DeleteKeyt/zh.json": 80483,
	"./components/service/modal/Emission/ar.json": 51689,
	"./components/service/modal/Emission/cs.json": 31460,
	"./components/service/modal/Emission/de.json": 12181,
	"./components/service/modal/Emission/en.json": 18073,
	"./components/service/modal/Emission/es.json": 4906,
	"./components/service/modal/Emission/fr.json": 97026,
	"./components/service/modal/Emission/hi.json": 1077,
	"./components/service/modal/Emission/it.json": 763,
	"./components/service/modal/Emission/kk.json": 27684,
	"./components/service/modal/Emission/pl.json": 50670,
	"./components/service/modal/Emission/pt.json": 99702,
	"./components/service/modal/Emission/ru.json": 91467,
	"./components/service/modal/Emission/uk.json": 72914,
	"./components/service/modal/Emission/zh.json": 34020,
	"./components/service/modal/History/ar.json": 57588,
	"./components/service/modal/History/cs.json": 26141,
	"./components/service/modal/History/de.json": 90720,
	"./components/service/modal/History/en.json": 97532,
	"./components/service/modal/History/es.json": 79627,
	"./components/service/modal/History/fr.json": 26663,
	"./components/service/modal/History/hi.json": 57000,
	"./components/service/modal/History/it.json": 99490,
	"./components/service/modal/History/kk.json": 58253,
	"./components/service/modal/History/pl.json": 447,
	"./components/service/modal/History/pt.json": 10055,
	"./components/service/modal/History/ru.json": 56494,
	"./components/service/modal/History/uk.json": 93203,
	"./components/service/modal/History/zh.json": 51917,
	"./components/service/modal/HistoryFilter/ar.json": 81230,
	"./components/service/modal/HistoryFilter/cs.json": 89219,
	"./components/service/modal/HistoryFilter/de.json": 67974,
	"./components/service/modal/HistoryFilter/en.json": 46142,
	"./components/service/modal/HistoryFilter/es.json": 43893,
	"./components/service/modal/HistoryFilter/fr.json": 39581,
	"./components/service/modal/HistoryFilter/hi.json": 86174,
	"./components/service/modal/HistoryFilter/it.json": 1640,
	"./components/service/modal/HistoryFilter/kk.json": 92995,
	"./components/service/modal/HistoryFilter/pl.json": 57669,
	"./components/service/modal/HistoryFilter/pt.json": 25757,
	"./components/service/modal/HistoryFilter/ru.json": 62616,
	"./components/service/modal/HistoryFilter/uk.json": 11517,
	"./components/service/modal/HistoryFilter/zh.json": 20567,
	"./components/service/modal/InvoiceDetails/ar.json": 77289,
	"./components/service/modal/InvoiceDetails/cs.json": 49604,
	"./components/service/modal/InvoiceDetails/de.json": 30325,
	"./components/service/modal/InvoiceDetails/en.json": 10041,
	"./components/service/modal/InvoiceDetails/es.json": 85354,
	"./components/service/modal/InvoiceDetails/fr.json": 41474,
	"./components/service/modal/InvoiceDetails/hi.json": 31669,
	"./components/service/modal/InvoiceDetails/it.json": 7515,
	"./components/service/modal/InvoiceDetails/kk.json": 45828,
	"./components/service/modal/InvoiceDetails/pl.json": 54414,
	"./components/service/modal/InvoiceDetails/pt.json": 75318,
	"./components/service/modal/InvoiceDetails/ru.json": 9611,
	"./components/service/modal/InvoiceDetails/uk.json": 94066,
	"./components/service/modal/InvoiceDetails/zh.json": 98244,
	"./components/service/modal/InvoicesFilter/ar.json": 64906,
	"./components/service/modal/InvoicesFilter/cs.json": 20287,
	"./components/service/modal/InvoicesFilter/de.json": 530,
	"./components/service/modal/InvoicesFilter/en.json": 33850,
	"./components/service/modal/InvoicesFilter/es.json": 73193,
	"./components/service/modal/InvoicesFilter/fr.json": 43889,
	"./components/service/modal/InvoicesFilter/hi.json": 68266,
	"./components/service/modal/InvoicesFilter/it.json": 78684,
	"./components/service/modal/InvoicesFilter/kk.json": 70303,
	"./components/service/modal/InvoicesFilter/pl.json": 25785,
	"./components/service/modal/InvoicesFilter/pt.json": 5569,
	"./components/service/modal/InvoicesFilter/ru.json": 26828,
	"./components/service/modal/InvoicesFilter/uk.json": 12513,
	"./components/service/modal/InvoicesFilter/zh.json": 43987,
	"./components/service/modal/KycConfirm/ar.json": 24953,
	"./components/service/modal/KycConfirm/cs.json": 23892,
	"./components/service/modal/KycConfirm/de.json": 12869,
	"./components/service/modal/KycConfirm/en.json": 62345,
	"./components/service/modal/KycConfirm/es.json": 41850,
	"./components/service/modal/KycConfirm/fr.json": 76626,
	"./components/service/modal/KycConfirm/hi.json": 65477,
	"./components/service/modal/KycConfirm/it.json": 90379,
	"./components/service/modal/KycConfirm/kk.json": 27220,
	"./components/service/modal/KycConfirm/pl.json": 8894,
	"./components/service/modal/KycConfirm/pt.json": 32998,
	"./components/service/modal/KycConfirm/ru.json": 2459,
	"./components/service/modal/KycConfirm/uk.json": 50242,
	"./components/service/modal/KycConfirm/zh.json": 62004,
	"./components/service/modal/MembersModal/ar.json": 56304,
	"./components/service/modal/MembersModal/cs.json": 73689,
	"./components/service/modal/MembersModal/de.json": 892,
	"./components/service/modal/MembersModal/en.json": 7400,
	"./components/service/modal/MembersModal/es.json": 27119,
	"./components/service/modal/MembersModal/fr.json": 86779,
	"./components/service/modal/MembersModal/hi.json": 78116,
	"./components/service/modal/MembersModal/it.json": 91558,
	"./components/service/modal/MembersModal/kk.json": 48665,
	"./components/service/modal/MembersModal/pl.json": 66851,
	"./components/service/modal/MembersModal/pt.json": 68331,
	"./components/service/modal/MembersModal/ru.json": 31426,
	"./components/service/modal/MembersModal/uk.json": 86247,
	"./components/service/modal/MembersModal/zh.json": 35577,
	"./components/service/modal/PayHref/ar.json": 9449,
	"./components/service/modal/PayHref/cs.json": 81988,
	"./components/service/modal/PayHref/de.json": 93237,
	"./components/service/modal/PayHref/en.json": 25977,
	"./components/service/modal/PayHref/es.json": 12682,
	"./components/service/modal/PayHref/fr.json": 99042,
	"./components/service/modal/PayHref/hi.json": 72565,
	"./components/service/modal/PayHref/it.json": 48955,
	"./components/service/modal/PayHref/kk.json": 78212,
	"./components/service/modal/PayHref/pl.json": 21934,
	"./components/service/modal/PayHref/pt.json": 71190,
	"./components/service/modal/PayHref/ru.json": 72523,
	"./components/service/modal/PayHref/uk.json": 56978,
	"./components/service/modal/PayHref/zh.json": 27204,
	"./components/service/modal/PayPass/ar.json": 59573,
	"./components/service/modal/PayPass/cs.json": 86720,
	"./components/service/modal/PayPass/de.json": 12977,
	"./components/service/modal/PayPass/en.json": 29669,
	"./components/service/modal/PayPass/es.json": 3822,
	"./components/service/modal/PayPass/fr.json": 53030,
	"./components/service/modal/PayPass/hi.json": 61553,
	"./components/service/modal/PayPass/it.json": 75327,
	"./components/service/modal/PayPass/kk.json": 82672,
	"./components/service/modal/PayPass/pl.json": 82594,
	"./components/service/modal/PayPass/pt.json": 92810,
	"./components/service/modal/PayPass/ru.json": 12303,
	"./components/service/modal/PayPass/uk.json": 42470,
	"./components/service/modal/PayPass/zh.json": 4336,
	"./components/service/modal/PaySelect/ar.json": 42126,
	"./components/service/modal/PaySelect/cs.json": 50115,
	"./components/service/modal/PaySelect/de.json": 28870,
	"./components/service/modal/PaySelect/en.json": 90686,
	"./components/service/modal/PaySelect/es.json": 88437,
	"./components/service/modal/PaySelect/fr.json": 477,
	"./components/service/modal/PaySelect/hi.json": 30718,
	"./components/service/modal/PaySelect/it.json": 46184,
	"./components/service/modal/PaySelect/kk.json": 53891,
	"./components/service/modal/PaySelect/pl.json": 2213,
	"./components/service/modal/PaySelect/pt.json": 86653,
	"./components/service/modal/PaySelect/ru.json": 23512,
	"./components/service/modal/PaySelect/uk.json": 56061,
	"./components/service/modal/PaySelect/zh.json": 81463,
	"./components/service/modal/PayStatus/ar.json": 99640,
	"./components/service/modal/PayStatus/cs.json": 2657,
	"./components/service/modal/PayStatus/de.json": 52708,
	"./components/service/modal/PayStatus/en.json": 43584,
	"./components/service/modal/PayStatus/es.json": 32823,
	"./components/service/modal/PayStatus/fr.json": 30947,
	"./components/service/modal/PayStatus/hi.json": 84524,
	"./components/service/modal/PayStatus/it.json": 78750,
	"./components/service/modal/PayStatus/kk.json": 1505,
	"./components/service/modal/PayStatus/pl.json": 26171,
	"./components/service/modal/PayStatus/pt.json": 57683,
	"./components/service/modal/PayStatus/ru.json": 54090,
	"./components/service/modal/PayStatus/uk.json": 26783,
	"./components/service/modal/PayStatus/zh.json": 13377,
	"./components/service/modal/Questionnaire/ar.json": 1839,
	"./components/service/modal/Questionnaire/cs.json": 3494,
	"./components/service/modal/Questionnaire/de.json": 21351,
	"./components/service/modal/Questionnaire/en.json": 54079,
	"./components/service/modal/Questionnaire/es.json": 79544,
	"./components/service/modal/Questionnaire/fr.json": 78332,
	"./components/service/modal/Questionnaire/hi.json": 98239,
	"./components/service/modal/Questionnaire/it.json": 78053,
	"./components/service/modal/Questionnaire/kk.json": 69750,
	"./components/service/modal/Questionnaire/pl.json": 54792,
	"./components/service/modal/Questionnaire/pt.json": 82240,
	"./components/service/modal/Questionnaire/ru.json": 80073,
	"./components/service/modal/Questionnaire/uk.json": 54176,
	"./components/service/modal/Questionnaire/zh.json": 61874,
	"./components/service/modal/ReEshop/ar.json": 35764,
	"./components/service/modal/ReEshop/cs.json": 42237,
	"./components/service/modal/ReEshop/de.json": 68576,
	"./components/service/modal/ReEshop/en.json": 79612,
	"./components/service/modal/ReEshop/es.json": 10123,
	"./components/service/modal/ReEshop/fr.json": 99911,
	"./components/service/modal/ReEshop/hi.json": 70472,
	"./components/service/modal/ReEshop/it.json": 50946,
	"./components/service/modal/ReEshop/kk.json": 31821,
	"./components/service/modal/ReEshop/pl.json": 54239,
	"./components/service/modal/ReEshop/pt.json": 61383,
	"./components/service/modal/ReEshop/ru.json": 87214,
	"./components/service/modal/ReEshop/uk.json": 23923,
	"./components/service/modal/ReEshop/zh.json": 25485,
	"./components/service/modal/Rename/ar.json": 54094,
	"./components/service/modal/Rename/cs.json": 40707,
	"./components/service/modal/Rename/de.json": 35270,
	"./components/service/modal/Rename/en.json": 33726,
	"./components/service/modal/Rename/es.json": 64437,
	"./components/service/modal/Rename/fr.json": 38941,
	"./components/service/modal/Rename/hi.json": 90366,
	"./components/service/modal/Rename/it.json": 89224,
	"./components/service/modal/Rename/kk.json": 44483,
	"./components/service/modal/Rename/pl.json": 8837,
	"./components/service/modal/Rename/pt.json": 55869,
	"./components/service/modal/Rename/ru.json": 62104,
	"./components/service/modal/Rename/uk.json": 77085,
	"./components/service/modal/Rename/zh.json": 8151,
	"./components/service/modal/Repeat/ar.json": 99349,
	"./components/service/modal/Repeat/cs.json": 42848,
	"./components/service/modal/Repeat/de.json": 69105,
	"./components/service/modal/Repeat/en.json": 69445,
	"./components/service/modal/Repeat/es.json": 59950,
	"./components/service/modal/Repeat/fr.json": 9158,
	"./components/service/modal/Repeat/hi.json": 1329,
	"./components/service/modal/Repeat/it.json": 31455,
	"./components/service/modal/Repeat/kk.json": 22448,
	"./components/service/modal/Repeat/pl.json": 38722,
	"./components/service/modal/Repeat/pt.json": 48938,
	"./components/service/modal/Repeat/ru.json": 52079,
	"./components/service/modal/Repeat/uk.json": 98598,
	"./components/service/modal/Repeat/zh.json": 60464,
	"./components/service/modal/SupportList/ar.json": 80837,
	"./components/service/modal/SupportList/cs.json": 73008,
	"./components/service/modal/SupportList/de.json": 60225,
	"./components/service/modal/SupportList/en.json": 63893,
	"./components/service/modal/SupportList/es.json": 88158,
	"./components/service/modal/SupportList/fr.json": 45078,
	"./components/service/modal/SupportList/hi.json": 62721,
	"./components/service/modal/SupportList/it.json": 4751,
	"./components/service/modal/SupportList/kk.json": 96160,
	"./components/service/modal/SupportList/pl.json": 52530,
	"./components/service/modal/SupportList/pt.json": 51514,
	"./components/service/modal/SupportList/ru.json": 34175,
	"./components/service/modal/SupportList/uk.json": 28086,
	"./components/service/modal/SupportList/zh.json": 69728,
	"./components/service/modal/Template/ar.json": 42406,
	"./components/service/modal/Template/cs.json": 52443,
	"./components/service/modal/Template/de.json": 95198,
	"./components/service/modal/Template/en.json": 98662,
	"./components/service/modal/Template/es.json": 3853,
	"./components/service/modal/Template/fr.json": 48501,
	"./components/service/modal/Template/hi.json": 65942,
	"./components/service/modal/Template/it.json": 11056,
	"./components/service/modal/Template/kk.json": 47739,
	"./components/service/modal/Template/pl.json": 97709,
	"./components/service/modal/Template/pt.json": 44277,
	"./components/service/modal/Template/ru.json": 28496,
	"./components/service/modal/Template/uk.json": 22277,
	"./components/service/modal/Template/zh.json": 79311,
	"./components/service/modal/TestMoney/ar.json": 45980,
	"./components/service/modal/TestMoney/cs.json": 11557,
	"./components/service/modal/TestMoney/de.json": 53736,
	"./components/service/modal/TestMoney/en.json": 77908,
	"./components/service/modal/TestMoney/es.json": 28947,
	"./components/service/modal/TestMoney/fr.json": 17903,
	"./components/service/modal/TestMoney/hi.json": 98960,
	"./components/service/modal/TestMoney/it.json": 61050,
	"./components/service/modal/TestMoney/kk.json": 65301,
	"./components/service/modal/TestMoney/pl.json": 11511,
	"./components/service/modal/TestMoney/pt.json": 89199,
	"./components/service/modal/TestMoney/ru.json": 75798,
	"./components/service/modal/TestMoney/uk.json": 11467,
	"./components/service/modal/TestMoney/zh.json": 77173,
	"./components/service/modal/Warning/ar.json": 54136,
	"./components/service/modal/Warning/cs.json": 57153,
	"./components/service/modal/Warning/de.json": 73028,
	"./components/service/modal/Warning/en.json": 55424,
	"./components/service/modal/Warning/es.json": 42167,
	"./components/service/modal/Warning/fr.json": 97763,
	"./components/service/modal/Warning/hi.json": 45964,
	"./components/service/modal/Warning/it.json": 63870,
	"./components/service/modal/Warning/kk.json": 64769,
	"./components/service/modal/Warning/pl.json": 8795,
	"./components/service/modal/Warning/pt.json": 78003,
	"./components/service/modal/Warning/ru.json": 94058,
	"./components/service/modal/Warning/uk.json": 93599,
	"./components/service/modal/Warning/zh.json": 76641,
	"./components/service/modal/WidgetData/ar.json": 1192,
	"./components/service/modal/WidgetData/cs.json": 39953,
	"./components/service/modal/WidgetData/de.json": 46228,
	"./components/service/modal/WidgetData/en.json": 81264,
	"./components/service/modal/WidgetData/es.json": 58599,
	"./components/service/modal/WidgetData/fr.json": 5619,
	"./components/service/modal/WidgetData/hi.json": 82396,
	"./components/service/modal/WidgetData/it.json": 92686,
	"./components/service/modal/WidgetData/kk.json": 36177,
	"./components/service/modal/WidgetData/pl.json": 30059,
	"./components/service/modal/WidgetData/pt.json": 63779,
	"./components/service/modal/WidgetData/ru.json": 75418,
	"./components/service/modal/WidgetData/uk.json": 91599,
	"./components/service/modal/WidgetData/zh.json": 99089,
	"./components/service/modal/p2p/AdInfo/ar.json": 7450,
	"./components/service/modal/p2p/AdInfo/cs.json": 18639,
	"./components/service/modal/p2p/AdInfo/de.json": 18754,
	"./components/service/modal/p2p/AdInfo/en.json": 34730,
	"./components/service/modal/p2p/AdInfo/es.json": 59417,
	"./components/service/modal/p2p/AdInfo/fr.json": 99169,
	"./components/service/modal/p2p/AdInfo/hi.json": 92378,
	"./components/service/modal/p2p/AdInfo/it.json": 58540,
	"./components/service/modal/p2p/AdInfo/kk.json": 22415,
	"./components/service/modal/p2p/AdInfo/pl.json": 49929,
	"./components/service/modal/p2p/AdInfo/pt.json": 88913,
	"./components/service/modal/p2p/AdInfo/ru.json": 24220,
	"./components/service/modal/p2p/AdInfo/uk.json": 71825,
	"./components/service/modal/p2p/AdInfo/zh.json": 26275,
	"./components/service/modal/p2p/CancelAdmin/ar.json": 76104,
	"./components/service/modal/p2p/CancelAdmin/cs.json": 34097,
	"./components/service/modal/p2p/CancelAdmin/de.json": 72724,
	"./components/service/modal/p2p/CancelAdmin/en.json": 17552,
	"./components/service/modal/p2p/CancelAdmin/es.json": 85095,
	"./components/service/modal/p2p/CancelAdmin/fr.json": 10963,
	"./components/service/modal/p2p/CancelAdmin/hi.json": 65820,
	"./components/service/modal/p2p/CancelAdmin/it.json": 40974,
	"./components/service/modal/p2p/CancelAdmin/kk.json": 30321,
	"./components/service/modal/p2p/CancelAdmin/pl.json": 99307,
	"./components/service/modal/p2p/CancelAdmin/pt.json": 43280,
	"./components/service/modal/p2p/CancelAdmin/ru.json": 50330,
	"./components/service/modal/p2p/CancelAdmin/uk.json": 44495,
	"./components/service/modal/p2p/CancelAdmin/zh.json": 4625,
	"./components/service/modal/p2p/CompleteAdmin/ar.json": 80533,
	"./components/service/modal/p2p/CompleteAdmin/cs.json": 77056,
	"./components/service/modal/p2p/CompleteAdmin/de.json": 68273,
	"./components/service/modal/p2p/CompleteAdmin/en.json": 93701,
	"./components/service/modal/p2p/CompleteAdmin/es.json": 30670,
	"./components/service/modal/p2p/CompleteAdmin/fr.json": 74438,
	"./components/service/modal/p2p/CompleteAdmin/hi.json": 88177,
	"./components/service/modal/p2p/CompleteAdmin/it.json": 41599,
	"./components/service/modal/p2p/CompleteAdmin/kk.json": 42256,
	"./components/service/modal/p2p/CompleteAdmin/pl.json": 3874,
	"./components/service/modal/p2p/CompleteAdmin/pt.json": 35786,
	"./components/service/modal/p2p/CompleteAdmin/ru.json": 65647,
	"./components/service/modal/p2p/CompleteAdmin/uk.json": 47526,
	"./components/service/modal/p2p/CompleteAdmin/zh.json": 6064,
	"./components/service/modal/p2p/ConfirmInternalPay/ar.json": 88102,
	"./components/service/modal/p2p/ConfirmInternalPay/cs.json": 98139,
	"./components/service/modal/p2p/ConfirmInternalPay/de.json": 40894,
	"./components/service/modal/p2p/ConfirmInternalPay/en.json": 28006,
	"./components/service/modal/p2p/ConfirmInternalPay/es.json": 49549,
	"./components/service/modal/p2p/ConfirmInternalPay/fr.json": 94197,
	"./components/service/modal/p2p/ConfirmInternalPay/hi.json": 11638,
	"./components/service/modal/p2p/ConfirmInternalPay/it.json": 40400,
	"./components/service/modal/p2p/ConfirmInternalPay/kk.json": 77083,
	"./components/service/modal/p2p/ConfirmInternalPay/pl.json": 43405,
	"./components/service/modal/p2p/ConfirmInternalPay/pt.json": 73621,
	"./components/service/modal/p2p/ConfirmInternalPay/ru.json": 57840,
	"./components/service/modal/p2p/ConfirmInternalPay/uk.json": 67973,
	"./components/service/modal/p2p/ConfirmInternalPay/zh.json": 25007,
	"./components/service/modal/p2p/OffersFilters/ar.json": 41753,
	"./components/service/modal/p2p/OffersFilters/cs.json": 14548,
	"./components/service/modal/p2p/OffersFilters/de.json": 3205,
	"./components/service/modal/p2p/OffersFilters/en.json": 62793,
	"./components/service/modal/p2p/OffersFilters/es.json": 79162,
	"./components/service/modal/p2p/OffersFilters/fr.json": 97586,
	"./components/service/modal/p2p/OffersFilters/hi.json": 35173,
	"./components/service/modal/p2p/OffersFilters/it.json": 7435,
	"./components/service/modal/p2p/OffersFilters/kk.json": 56020,
	"./components/service/modal/p2p/OffersFilters/pl.json": 46206,
	"./components/service/modal/p2p/OffersFilters/pt.json": 18726,
	"./components/service/modal/p2p/OffersFilters/ru.json": 14811,
	"./components/service/modal/p2p/OffersFilters/uk.json": 87874,
	"./components/service/modal/p2p/OffersFilters/zh.json": 52660,
	"./components/service/modal/p2p/SwapsFilters/ar.json": 24892,
	"./components/service/modal/p2p/SwapsFilters/cs.json": 90469,
	"./components/service/modal/p2p/SwapsFilters/de.json": 49000,
	"./components/service/modal/p2p/SwapsFilters/en.json": 56820,
	"./components/service/modal/p2p/SwapsFilters/es.json": 24211,
	"./components/service/modal/p2p/SwapsFilters/fr.json": 96815,
	"./components/service/modal/p2p/SwapsFilters/hi.json": 77872,
	"./components/service/modal/p2p/SwapsFilters/it.json": 39962,
	"./components/service/modal/p2p/SwapsFilters/kk.json": 60565,
	"./components/service/modal/p2p/SwapsFilters/pl.json": 90423,
	"./components/service/modal/p2p/SwapsFilters/pt.json": 68111,
	"./components/service/modal/p2p/SwapsFilters/ru.json": 54710,
	"./components/service/modal/p2p/SwapsFilters/uk.json": 12760,
	"./components/service/modal/p2p/SwapsFilters/zh.json": 72437,
	"./components/service/modlas/Repeat/ar.json": 33596,
	"./components/service/modlas/Repeat/cs.json": 29797,
	"./components/service/modlas/Repeat/de.json": 21960,
	"./components/service/modlas/Repeat/en.json": 42228,
	"./components/service/modlas/Repeat/es.json": 9491,
	"./components/service/modlas/Repeat/fr.json": 62991,
	"./components/service/modlas/Repeat/hi.json": 48880,
	"./components/service/modlas/Repeat/it.json": 79290,
	"./components/service/modlas/Repeat/kk.json": 33525,
	"./components/service/modlas/Repeat/pl.json": 60503,
	"./components/service/modlas/Repeat/pt.json": 43023,
	"./components/service/modlas/Repeat/ru.json": 44566,
	"./components/service/modlas/Repeat/uk.json": 84683,
	"./components/service/modlas/Repeat/zh.json": 57845,
	"./components/service/p2p/CreateExternal/ar.json": 3350,
	"./components/service/p2p/CreateExternal/cs.json": 53611,
	"./components/service/p2p/CreateExternal/de.json": 88302,
	"./components/service/p2p/CreateExternal/en.json": 43542,
	"./components/service/p2p/CreateExternal/es.json": 69373,
	"./components/service/p2p/CreateExternal/fr.json": 3653,
	"./components/service/p2p/CreateExternal/hi.json": 48454,
	"./components/service/p2p/CreateExternal/it.json": 41376,
	"./components/service/p2p/CreateExternal/kk.json": 49835,
	"./components/service/p2p/CreateExternal/pl.json": 7517,
	"./components/service/p2p/CreateExternal/pt.json": 39429,
	"./components/service/p2p/CreateExternal/ru.json": 28160,
	"./components/service/p2p/CreateExternal/uk.json": 3669,
	"./components/service/p2p/CreateExternal/zh.json": 53759,
	"./components/service/p2p/DealStagesContent/ar.json": 38735,
	"./components/service/p2p/DealStagesContent/cs.json": 18822,
	"./components/service/p2p/DealStagesContent/de.json": 27847,
	"./components/service/p2p/DealStagesContent/en.json": 91519,
	"./components/service/p2p/DealStagesContent/es.json": 59512,
	"./components/service/p2p/DealStagesContent/fr.json": 66812,
	"./components/service/p2p/DealStagesContent/hi.json": 58431,
	"./components/service/p2p/DealStagesContent/it.json": 38245,
	"./components/service/p2p/DealStagesContent/kk.json": 1526,
	"./components/service/p2p/DealStagesContent/pl.json": 74664,
	"./components/service/p2p/DealStagesContent/pt.json": 40192,
	"./components/service/p2p/DealStagesContent/ru.json": 2569,
	"./components/service/p2p/DealStagesContent/uk.json": 38432,
	"./components/service/p2p/DealStagesContent/zh.json": 98770,
	"./components/service/pagination/ar.json": 13666,
	"./components/service/pagination/cs.json": 65303,
	"./components/service/pagination/de.json": 32746,
	"./components/service/pagination/en.json": 56866,
	"./components/service/pagination/es.json": 76385,
	"./components/service/pagination/fr.json": 51977,
	"./components/service/pagination/hi.json": 75554,
	"./components/service/pagination/it.json": 44580,
	"./components/service/pagination/kk.json": 61527,
	"./components/service/pagination/pl.json": 94529,
	"./components/service/pagination/pt.json": 78009,
	"./components/service/pagination/ru.json": 92548,
	"./components/service/pagination/uk.json": 68969,
	"./components/service/pagination/zh.json": 26091,
	"./components/service/topmenu/ar.json": 9086,
	"./components/service/topmenu/cs.json": 3699,
	"./components/service/topmenu/de.json": 16022,
	"./components/service/topmenu/en.json": 64302,
	"./components/service/topmenu/es.json": 66853,
	"./components/service/topmenu/fr.json": 14733,
	"./components/service/topmenu/hi.json": 73262,
	"./components/service/topmenu/it.json": 3800,
	"./components/service/topmenu/kk.json": 47827,
	"./components/service/topmenu/pl.json": 31157,
	"./components/service/topmenu/pt.json": 57869,
	"./components/service/topmenu/ru.json": 94728,
	"./components/service/topmenu/uk.json": 12877,
	"./components/service/topmenu/zh.json": 99655,
	"./components/virtAct/Stages/ar.json": 12045,
	"./components/virtAct/Stages/cs.json": 95576,
	"./components/virtAct/Stages/de.json": 49897,
	"./components/virtAct/Stages/en.json": 75021,
	"./components/virtAct/Stages/es.json": 19526,
	"./components/virtAct/Stages/fr.json": 6398,
	"./components/virtAct/Stages/hi.json": 48553,
	"./components/virtAct/Stages/it.json": 45639,
	"./components/virtAct/Stages/kk.json": 13160,
	"./components/virtAct/Stages/pl.json": 4170,
	"./components/virtAct/Stages/pt.json": 51426,
	"./components/virtAct/Stages/ru.json": 58855,
	"./components/virtAct/Stages/uk.json": 70958,
	"./components/virtAct/Stages/zh.json": 74472,
	"./iews/Echeck/New/ar.json": 17430,
	"./iews/Echeck/New/cs.json": 46219,
	"./iews/Echeck/New/de.json": 38158,
	"./iews/Echeck/New/en.json": 12854,
	"./iews/Echeck/New/es.json": 92733,
	"./iews/Echeck/New/fr.json": 69541,
	"./iews/Echeck/New/hi.json": 48294,
	"./iews/Echeck/New/it.json": 12928,
	"./iews/Echeck/New/kk.json": 42443,
	"./iews/Echeck/New/pl.json": 48317,
	"./iews/Echeck/New/pt.json": 8741,
	"./iews/Echeck/New/ru.json": 99712,
	"./iews/Echeck/New/uk.json": 46261,
	"./iews/Echeck/New/zh.json": 13407,
	"./views/ATM/ar.json": 42206,
	"./views/ATM/cs.json": 7251,
	"./views/ATM/de.json": 53846,
	"./views/ATM/en.json": 66350,
	"./views/ATM/es.json": 73509,
	"./views/ATM/fr.json": 21389,
	"./views/ATM/hi.json": 53518,
	"./views/ATM/it.json": 16120,
	"./views/ATM/kk.json": 90995,
	"./views/ATM/pl.json": 40469,
	"./views/ATM/pt.json": 43885,
	"./views/ATM/ru.json": 54024,
	"./views/ATM/uk.json": 15245,
	"./views/ATM/zh.json": 96135,
	"./views/ATMDevices/ar.json": 59639,
	"./views/ATMDevices/cs.json": 15790,
	"./views/ATMDevices/de.json": 11567,
	"./views/ATMDevices/en.json": 34007,
	"./views/ATMDevices/es.json": 98688,
	"./views/ATMDevices/fr.json": 30948,
	"./views/ATMDevices/hi.json": 42439,
	"./views/ATMDevices/it.json": 23549,
	"./views/ATMDevices/kk.json": 70142,
	"./views/ATMDevices/pl.json": 7488,
	"./views/ATMDevices/pt.json": 37512,
	"./views/ATMDevices/ru.json": 28625,
	"./views/ATMDevices/uk.json": 30488,
	"./views/ATMDevices/zh.json": 81050,
	"./views/ATMIncass/ar.json": 94041,
	"./views/ATMIncass/cs.json": 13812,
	"./views/ATMIncass/de.json": 2469,
	"./views/ATMIncass/en.json": 81289,
	"./views/ATMIncass/es.json": 24506,
	"./views/ATMIncass/fr.json": 39922,
	"./views/ATMIncass/hi.json": 60741,
	"./views/ATMIncass/it.json": 6699,
	"./views/ATMIncass/kk.json": 12212,
	"./views/ATMIncass/pl.json": 49022,
	"./views/ATMIncass/pt.json": 87238,
	"./views/ATMIncass/ru.json": 71547,
	"./views/ATMIncass/uk.json": 16866,
	"./views/ATMIncass/zh.json": 51924,
	"./views/ATMIncassBalance/ar.json": 72807,
	"./views/ATMIncassBalance/cs.json": 68350,
	"./views/ATMIncassBalance/de.json": 91487,
	"./views/ATMIncassBalance/en.json": 12711,
	"./views/ATMIncassBalance/es.json": 35376,
	"./views/ATMIncassBalance/fr.json": 98164,
	"./views/ATMIncassBalance/hi.json": 45079,
	"./views/ATMIncassBalance/it.json": 22861,
	"./views/ATMIncassBalance/kk.json": 97742,
	"./views/ATMIncassBalance/pl.json": 17104,
	"./views/ATMIncassBalance/pt.json": 80696,
	"./views/ATMIncassBalance/ru.json": 81217,
	"./views/ATMIncassBalance/uk.json": 50216,
	"./views/ATMIncassBalance/zh.json": 56234,
	"./views/ATMIncassItem/ar.json": 62516,
	"./views/ATMIncassItem/cs.json": 60093,
	"./views/ATMIncassItem/de.json": 29504,
	"./views/ATMIncassItem/en.json": 75740,
	"./views/ATMIncassItem/es.json": 75499,
	"./views/ATMIncassItem/fr.json": 37159,
	"./views/ATMIncassItem/hi.json": 4680,
	"./views/ATMIncassItem/it.json": 77698,
	"./views/ATMIncassItem/kk.json": 4653,
	"./views/ATMIncassItem/pl.json": 15167,
	"./views/ATMIncassItem/pt.json": 88135,
	"./views/ATMIncassItem/ru.json": 83214,
	"./views/ATMIncassItem/uk.json": 76979,
	"./views/ATMIncassItem/zh.json": 52237,
	"./views/ATMIncassStatuses/ar.json": 32859,
	"./views/ATMIncassStatuses/cs.json": 28706,
	"./views/ATMIncassStatuses/de.json": 28995,
	"./views/ATMIncassStatuses/en.json": 61835,
	"./views/ATMIncassStatuses/es.json": 45724,
	"./views/ATMIncassStatuses/fr.json": 8112,
	"./views/ATMIncassStatuses/hi.json": 70971,
	"./views/ATMIncassStatuses/it.json": 2633,
	"./views/ATMIncassStatuses/kk.json": 7010,
	"./views/ATMIncassStatuses/pl.json": 55148,
	"./views/ATMIncassStatuses/pt.json": 46516,
	"./views/ATMIncassStatuses/ru.json": 67853,
	"./views/ATMIncassStatuses/uk.json": 2356,
	"./views/ATMIncassStatuses/zh.json": 28062,
	"./views/ATMauth/ar.json": 21980,
	"./views/ATMauth/cs.json": 34533,
	"./views/ATMauth/de.json": 26696,
	"./views/ATMauth/en.json": 30612,
	"./views/ATMauth/es.json": 36608,
	"./views/ATMauth/fr.json": 51375,
	"./views/ATMauth/hi.json": 37264,
	"./views/ATMauth/it.json": 84026,
	"./views/ATMauth/kk.json": 38261,
	"./views/ATMauth/pl.json": 65239,
	"./views/ATMauth/pt.json": 31407,
	"./views/ATMauth/ru.json": 32950,
	"./views/ATMauth/uk.json": 73067,
	"./views/ATMauth/zh.json": 46229,
	"./views/ChoiseColumns/ar.json": 41732,
	"./views/ChoiseColumns/cs.json": 94701,
	"./views/ChoiseColumns/de.json": 47344,
	"./views/ChoiseColumns/en.json": 80716,
	"./views/ChoiseColumns/es.json": 85819,
	"./views/ChoiseColumns/fr.json": 49463,
	"./views/ChoiseColumns/hi.json": 2584,
	"./views/ChoiseColumns/it.json": 18610,
	"./views/ChoiseColumns/kk.json": 27645,
	"./views/ChoiseColumns/pl.json": 81263,
	"./views/ChoiseColumns/pt.json": 97463,
	"./views/ChoiseColumns/ru.json": 20478,
	"./views/ChoiseColumns/uk.json": 95043,
	"./views/ChoiseColumns/zh.json": 45181,
	"./views/ChoiseKeyt/ar.json": 56456,
	"./views/ChoiseKeyt/cs.json": 95217,
	"./views/ChoiseKeyt/de.json": 85140,
	"./views/ChoiseKeyt/en.json": 36528,
	"./views/ChoiseKeyt/es.json": 13863,
	"./views/ChoiseKeyt/fr.json": 60883,
	"./views/ChoiseKeyt/hi.json": 37660,
	"./views/ChoiseKeyt/it.json": 31598,
	"./views/ChoiseKeyt/kk.json": 91441,
	"./views/ChoiseKeyt/pl.json": 85323,
	"./views/ChoiseKeyt/pt.json": 2691,
	"./views/ChoiseKeyt/ru.json": 14330,
	"./views/ChoiseKeyt/uk.json": 30511,
	"./views/ChoiseKeyt/zh.json": 54353,
	"./views/CollectorsList/ar.json": 68722,
	"./views/CollectorsList/cs.json": 53447,
	"./views/CollectorsList/de.json": 7738,
	"./views/CollectorsList/en.json": 73842,
	"./views/CollectorsList/es.json": 39633,
	"./views/CollectorsList/fr.json": 96537,
	"./views/CollectorsList/hi.json": 6386,
	"./views/CollectorsList/it.json": 55444,
	"./views/CollectorsList/kk.json": 62631,
	"./views/CollectorsList/pl.json": 30833,
	"./views/CollectorsList/pt.json": 76905,
	"./views/CollectorsList/ru.json": 19847,
	"./views/CollectorsList/uk.json": 23449,
	"./views/CollectorsList/zh.json": 74587,
	"./views/CorrInfo/ar.json": 10084,
	"./views/CorrInfo/cs.json": 56429,
	"./views/CorrInfo/de.json": 35248,
	"./views/CorrInfo/en.json": 27372,
	"./views/CorrInfo/es.json": 85243,
	"./views/CorrInfo/fr.json": 26871,
	"./views/CorrInfo/hi.json": 38872,
	"./views/CorrInfo/it.json": 94194,
	"./views/CorrInfo/kk.json": 38845,
	"./views/CorrInfo/pl.json": 80687,
	"./views/CorrInfo/pt.json": 2999,
	"./views/CorrInfo/ru.json": 89150,
	"./views/CorrInfo/uk.json": 36675,
	"./views/CorrInfo/zh.json": 8189,
	"./views/Doc/DocsHome/ar.json": 57407,
	"./views/Doc/DocsHome/cs.json": 33910,
	"./views/Doc/DocsHome/de.json": 45559,
	"./views/Doc/DocsHome/en.json": 36271,
	"./views/Doc/DocsHome/es.json": 66408,
	"./views/Doc/DocsHome/fr.json": 26124,
	"./views/Doc/DocsHome/hi.json": 53583,
	"./views/Doc/DocsHome/it.json": 41653,
	"./views/Doc/DocsHome/kk.json": 52358,
	"./views/Doc/DocsHome/pl.json": 74904,
	"./views/Doc/DocsHome/pt.json": 27664,
	"./views/Doc/DocsHome/ru.json": 81158,
	"./views/Doc/DocsHome/uk.json": 68976,
	"./views/Doc/DocsHome/zh.json": 5922,
	"./views/Doc/Merchant/ar.json": 86851,
	"./views/Doc/Merchant/cs.json": 66858,
	"./views/Doc/Merchant/de.json": 47243,
	"./views/Doc/Merchant/en.json": 95075,
	"./views/Doc/Merchant/es.json": 36164,
	"./views/Doc/Merchant/fr.json": 55544,
	"./views/Doc/Merchant/hi.json": 86115,
	"./views/Doc/Merchant/it.json": 17953,
	"./views/Doc/Merchant/kk.json": 86218,
	"./views/Doc/Merchant/pl.json": 80356,
	"./views/Doc/Merchant/pt.json": 58876,
	"./views/Doc/Merchant/ru.json": 89717,
	"./views/Doc/Merchant/uk.json": 68652,
	"./views/Doc/Merchant/zh.json": 59654,
	"./views/Doc/Widget/ar.json": 79335,
	"./views/Doc/Widget/cs.json": 46590,
	"./views/Doc/Widget/de.json": 61375,
	"./views/Doc/Widget/en.json": 7,
	"./views/Doc/Widget/es.json": 47792,
	"./views/Doc/Widget/fr.json": 10260,
	"./views/Doc/Widget/hi.json": 23,
	"./views/Doc/Widget/it.json": 55917,
	"./views/Doc/Widget/kk.json": 88046,
	"./views/Doc/Widget/pl.json": 77904,
	"./views/Doc/Widget/pt.json": 1848,
	"./views/Doc/Widget/ru.json": 86177,
	"./views/Doc/Widget/uk.json": 13896,
	"./views/Doc/Widget/zh.json": 6346,
	"./views/Echeck/Activate/ar.json": 28959,
	"./views/Echeck/Activate/cs.json": 89110,
	"./views/Echeck/Activate/de.json": 67895,
	"./views/Echeck/Activate/en.json": 11247,
	"./views/Echeck/Activate/es.json": 97640,
	"./views/Echeck/Activate/fr.json": 52364,
	"./views/Echeck/Activate/hi.json": 85487,
	"./views/Echeck/Activate/it.json": 67893,
	"./views/Echeck/Activate/kk.json": 77030,
	"./views/Echeck/Activate/pl.json": 58616,
	"./views/Echeck/Activate/pt.json": 34672,
	"./views/Echeck/Activate/ru.json": 35033,
	"./views/Echeck/Activate/uk.json": 17232,
	"./views/Echeck/Activate/zh.json": 32482,
	"./views/Echeck/List/ar.json": 66628,
	"./views/Echeck/List/cs.json": 35949,
	"./views/Echeck/List/de.json": 14768,
	"./views/Echeck/List/en.json": 5484,
	"./views/Echeck/List/es.json": 68187,
	"./views/Echeck/List/fr.json": 31831,
	"./views/Echeck/List/hi.json": 58232,
	"./views/Echeck/List/it.json": 16786,
	"./views/Echeck/List/kk.json": 59485,
	"./views/Echeck/List/pl.json": 60207,
	"./views/Echeck/List/pt.json": 35159,
	"./views/Echeck/List/ru.json": 86494,
	"./views/Echeck/List/uk.json": 47139,
	"./views/Echeck/List/zh.json": 78973,
	"./views/Echeck/New/ar.json": 52618,
	"./views/Echeck/New/cs.json": 97023,
	"./views/Echeck/New/de.json": 31186,
	"./views/Echeck/New/en.json": 78906,
	"./views/Echeck/New/es.json": 99401,
	"./views/Echeck/New/fr.json": 62225,
	"./views/Echeck/New/hi.json": 98922,
	"./views/Echeck/New/it.json": 35644,
	"./views/Echeck/New/kk.json": 92063,
	"./views/Echeck/New/pl.json": 70841,
	"./views/Echeck/New/pt.json": 78753,
	"./views/Echeck/New/ru.json": 64396,
	"./views/Echeck/New/uk.json": 60577,
	"./views/Echeck/New/zh.json": 31699,
	"./views/Error/ar.json": 9948,
	"./views/Error/cs.json": 75525,
	"./views/Error/de.json": 17704,
	"./views/Error/en.json": 41876,
	"./views/Error/es.json": 92915,
	"./views/Error/fr.json": 81871,
	"./views/Error/hi.json": 62928,
	"./views/Error/it.json": 25018,
	"./views/Error/kk.json": 29269,
	"./views/Error/pl.json": 75479,
	"./views/Error/pt.json": 53167,
	"./views/Error/ru.json": 39766,
	"./views/Error/uk.json": 75435,
	"./views/Error/zh.json": 57493,
	"./views/FreeReports/ar.json": 58129,
	"./views/FreeReports/cs.json": 84204,
	"./views/FreeReports/de.json": 86141,
	"./views/FreeReports/en.json": 22385,
	"./views/FreeReports/es.json": 56594,
	"./views/FreeReports/fr.json": 36202,
	"./views/FreeReports/hi.json": 98570,
	"./views/FreeReports/it.json": 93011,
	"./views/FreeReports/kk.json": 84076,
	"./views/FreeReports/pl.json": 31110,
	"./views/FreeReports/pt.json": 95230,
	"./views/FreeReports/ru.json": 39475,
	"./views/FreeReports/uk.json": 85290,
	"./views/FreeReports/zh.json": 37868,
	"./views/History/ar.json": 63438,
	"./views/History/cs.json": 71843,
	"./views/History/de.json": 16422,
	"./views/History/en.json": 12542,
	"./views/History/es.json": 2837,
	"./views/History/fr.json": 95485,
	"./views/History/hi.json": 87646,
	"./views/History/it.json": 71944,
	"./views/History/kk.json": 75619,
	"./views/History/pl.json": 40293,
	"./views/History/pt.json": 57981,
	"./views/History/ru.json": 37368,
	"./views/History/uk.json": 65469,
	"./views/History/zh.json": 14167,
	"./views/Home/ar.json": 32123,
	"./views/Home/cs.json": 27970,
	"./views/Home/de.json": 28259,
	"./views/Home/en.json": 61099,
	"./views/Home/es.json": 44988,
	"./views/Home/fr.json": 7376,
	"./views/Home/hi.json": 70235,
	"./views/Home/it.json": 1897,
	"./views/Home/kk.json": 6274,
	"./views/Home/pl.json": 54412,
	"./views/Home/pt.json": 45780,
	"./views/Home/ru.json": 67117,
	"./views/Home/uk.json": 1620,
	"./views/Home/zh.json": 27326,
	"./views/InfoCollector/ar.json": 4487,
	"./views/InfoCollector/cs.json": 79198,
	"./views/InfoCollector/de.json": 98431,
	"./views/InfoCollector/en.json": 71239,
	"./views/InfoCollector/es.json": 3696,
	"./views/InfoCollector/fr.json": 8212,
	"./views/InfoCollector/hi.json": 28727,
	"./views/InfoCollector/it.json": 81069,
	"./views/InfoCollector/kk.json": 56270,
	"./views/InfoCollector/pl.json": 91664,
	"./views/InfoCollector/pt.json": 38904,
	"./views/InfoCollector/ru.json": 71809,
	"./views/InfoCollector/uk.json": 94024,
	"./views/InfoCollector/zh.json": 34506,
	"./views/InfoReg/ar.json": 61916,
	"./views/InfoReg/cs.json": 74469,
	"./views/InfoReg/de.json": 66632,
	"./views/InfoReg/en.json": 70548,
	"./views/InfoReg/es.json": 54163,
	"./views/InfoReg/fr.json": 91311,
	"./views/InfoReg/hi.json": 77200,
	"./views/InfoReg/it.json": 23962,
	"./views/InfoReg/kk.json": 78197,
	"./views/InfoReg/pl.json": 5175,
	"./views/InfoReg/pt.json": 71343,
	"./views/InfoReg/ru.json": 72886,
	"./views/InfoReg/uk.json": 13003,
	"./views/InfoReg/zh.json": 86165,
	"./views/KYC/ar.json": 64061,
	"./views/KYC/cs.json": 35528,
	"./views/KYC/de.json": 16633,
	"./views/KYC/en.json": 47165,
	"./views/KYC/es.json": 2486,
	"./views/KYC/fr.json": 32238,
	"./views/KYC/hi.json": 94777,
	"./views/KYC/it.json": 23447,
	"./views/KYC/kk.json": 76568,
	"./views/KYC/pl.json": 87706,
	"./views/KYC/pt.json": 5074,
	"./views/KYC/ru.json": 80087,
	"./views/KYC/uk.json": 47230,
	"./views/KYC/zh.json": 15960,
	"./views/Keyts/List/ar.json": 87855,
	"./views/Keyts/List/cs.json": 67942,
	"./views/Keyts/List/de.json": 60615,
	"./views/Keyts/List/en.json": 24287,
	"./views/Keyts/List/es.json": 92280,
	"./views/Keyts/List/fr.json": 15932,
	"./views/Keyts/List/hi.json": 7551,
	"./views/Keyts/List/it.json": 87365,
	"./views/Keyts/List/kk.json": 50646,
	"./views/Keyts/List/pl.json": 23784,
	"./views/Keyts/List/pt.json": 72960,
	"./views/Keyts/List/ru.json": 74070,
	"./views/Keyts/List/uk.json": 87552,
	"./views/Keyts/List/zh.json": 47890,
	"./views/Keyts/New/ar.json": 43463,
	"./views/Keyts/New/cs.json": 55358,
	"./views/Keyts/New/de.json": 78495,
	"./views/Keyts/New/en.json": 99719,
	"./views/Keyts/New/es.json": 22384,
	"./views/Keyts/New/fr.json": 68820,
	"./views/Keyts/New/hi.json": 32087,
	"./views/Keyts/New/it.json": 9869,
	"./views/Keyts/New/kk.json": 68398,
	"./views/Keyts/New/pl.json": 4112,
	"./views/Keyts/New/pt.json": 51352,
	"./views/Keyts/New/ru.json": 51873,
	"./views/Keyts/New/uk.json": 37224,
	"./views/Keyts/New/zh.json": 26890,
	"./views/ListRates/ar.json": 44311,
	"./views/ListRates/cs.json": 43214,
	"./views/ListRates/de.json": 83247,
	"./views/ListRates/en.json": 62487,
	"./views/ListRates/es.json": 73248,
	"./views/ListRates/fr.json": 79108,
	"./views/ListRates/hi.json": 6823,
	"./views/ListRates/it.json": 36349,
	"./views/ListRates/kk.json": 71422,
	"./views/ListRates/pl.json": 92160,
	"./views/ListRates/pt.json": 64712,
	"./views/ListRates/ru.json": 55825,
	"./views/ListRates/uk.json": 78379,
	"./views/ListRates/zh.json": 63226,
	"./views/Login/ar.json": 53889,
	"./views/Login/cs.json": 40380,
	"./views/Login/de.json": 5965,
	"./views/Login/en.json": 51393,
	"./views/Login/es.json": 32194,
	"./views/Login/fr.json": 34042,
	"./views/Login/hi.json": 42989,
	"./views/Login/it.json": 26339,
	"./views/Login/kk.json": 44156,
	"./views/Login/pl.json": 83126,
	"./views/Login/pt.json": 34094,
	"./views/Login/ru.json": 23203,
	"./views/Login/uk.json": 69722,
	"./views/Login/zh.json": 3516,
	"./views/Masspayment/Info/ar.json": 75387,
	"./views/Masspayment/Info/cs.json": 74562,
	"./views/Masspayment/Info/de.json": 66019,
	"./views/Masspayment/Info/en.json": 64843,
	"./views/Masspayment/Info/es.json": 6044,
	"./views/Masspayment/Info/fr.json": 44912,
	"./views/Masspayment/Info/hi.json": 13499,
	"./views/Masspayment/Info/it.json": 20201,
	"./views/Masspayment/Info/kk.json": 97954,
	"./views/Masspayment/Info/pl.json": 22572,
	"./views/Masspayment/Info/pt.json": 72596,
	"./views/Masspayment/Info/ru.json": 36685,
	"./views/Masspayment/Info/uk.json": 71508,
	"./views/Masspayment/Info/zh.json": 66142,
	"./views/Masspayment/List/ar.json": 15439,
	"./views/Masspayment/List/cs.json": 79174,
	"./views/Masspayment/List/de.json": 88199,
	"./views/Masspayment/List/en.json": 51871,
	"./views/Masspayment/List/es.json": 19864,
	"./views/Masspayment/List/fr.json": 27164,
	"./views/Masspayment/List/hi.json": 18783,
	"./views/Masspayment/List/it.json": 98597,
	"./views/Masspayment/List/kk.json": 61878,
	"./views/Masspayment/List/pl.json": 35016,
	"./views/Masspayment/List/pt.json": 544,
	"./views/Masspayment/List/ru.json": 62921,
	"./views/Masspayment/List/uk.json": 98784,
	"./views/Masspayment/List/zh.json": 59122,
	"./views/Masspayment/New/ar.json": 41991,
	"./views/Masspayment/New/cs.json": 37534,
	"./views/Masspayment/New/de.json": 77023,
	"./views/Masspayment/New/en.json": 98247,
	"./views/Masspayment/New/es.json": 4560,
	"./views/Masspayment/New/fr.json": 67348,
	"./views/Masspayment/New/hi.json": 14263,
	"./views/Masspayment/New/it.json": 92045,
	"./views/Masspayment/New/kk.json": 66926,
	"./views/Masspayment/New/pl.json": 2640,
	"./views/Masspayment/New/pt.json": 49880,
	"./views/Masspayment/New/ru.json": 50401,
	"./views/Masspayment/New/uk.json": 19400,
	"./views/Masspayment/New/zh.json": 25418,
	"./views/Merchant/ChoiseCurrency/en.json": 85601,
	"./views/Merchant/ChoiseCurrency/ru.json": 64547,
	"./views/Merchant/ChoiseShop/ar.json": 64376,
	"./views/Merchant/ChoiseShop/cs.json": 51041,
	"./views/Merchant/ChoiseShop/de.json": 1092,
	"./views/Merchant/ChoiseShop/en.json": 91968,
	"./views/Merchant/ChoiseShop/es.json": 81207,
	"./views/Merchant/ChoiseShop/fr.json": 79331,
	"./views/Merchant/ChoiseShop/hi.json": 32908,
	"./views/Merchant/ChoiseShop/it.json": 27134,
	"./views/Merchant/ChoiseShop/kk.json": 49889,
	"./views/Merchant/ChoiseShop/pl.json": 74555,
	"./views/Merchant/ChoiseShop/pt.json": 6067,
	"./views/Merchant/ChoiseShop/ru.json": 2474,
	"./views/Merchant/ChoiseShop/uk.json": 75167,
	"./views/Merchant/ChoiseShop/zh.json": 61761,
	"./views/Merchant/DashboardInvoices/ar.json": 72375,
	"./views/Merchant/DashboardInvoices/cs.json": 40846,
	"./views/Merchant/DashboardInvoices/de.json": 20399,
	"./views/Merchant/DashboardInvoices/en.json": 58519,
	"./views/Merchant/DashboardInvoices/es.json": 41152,
	"./views/Merchant/DashboardInvoices/fr.json": 39236,
	"./views/Merchant/DashboardInvoices/hi.json": 60007,
	"./views/Merchant/DashboardInvoices/it.json": 82237,
	"./views/Merchant/DashboardInvoices/kk.json": 90750,
	"./views/Merchant/DashboardInvoices/pl.json": 23648,
	"./views/Merchant/DashboardInvoices/pt.json": 58120,
	"./views/Merchant/DashboardInvoices/ru.json": 25009,
	"./views/Merchant/DashboardInvoices/uk.json": 46648,
	"./views/Merchant/DashboardInvoices/zh.json": 25466,
	"./views/Merchant/Edit/ar.json": 35258,
	"./views/Merchant/Edit/cs.json": 52600,
	"./views/Merchant/Edit/de.json": 36329,
	"./views/Merchant/Edit/en.json": 92205,
	"./views/Merchant/Edit/es.json": 70662,
	"./views/Merchant/Edit/fr.json": 72318,
	"./views/Merchant/Edit/hi.json": 14473,
	"./views/Merchant/Edit/it.json": 36295,
	"./views/Merchant/Edit/kk.json": 62728,
	"./views/Merchant/Edit/pl.json": 41418,
	"./views/Merchant/Edit/pt.json": 25858,
	"./views/Merchant/Edit/ru.json": 49511,
	"./views/Merchant/Edit/uk.json": 10254,
	"./views/Merchant/Edit/zh.json": 19048,
	"./views/Merchant/Invoices/ar.json": 94893,
	"./views/Merchant/Invoices/cs.json": 78424,
	"./views/Merchant/Invoices/de.json": 32745,
	"./views/Merchant/Invoices/en.json": 80250,
	"./views/Merchant/Invoices/es.json": 2374,
	"./views/Merchant/Invoices/fr.json": 89246,
	"./views/Merchant/Invoices/hi.json": 31401,
	"./views/Merchant/Invoices/it.json": 28487,
	"./views/Merchant/Invoices/kk.json": 96008,
	"./views/Merchant/Invoices/pl.json": 87018,
	"./views/Merchant/Invoices/pt.json": 34274,
	"./views/Merchant/Invoices/ru.json": 41703,
	"./views/Merchant/Invoices/uk.json": 53806,
	"./views/Merchant/Invoices/zh.json": 40968,
	"./views/Merchant/List/ar.json": 21301,
	"./views/Merchant/List/cs.json": 17824,
	"./views/Merchant/List/de.json": 9041,
	"./views/Merchant/List/en.json": 34469,
	"./views/Merchant/List/es.json": 87790,
	"./views/Merchant/List/fr.json": 15206,
	"./views/Merchant/List/hi.json": 45297,
	"./views/Merchant/List/it.json": 82367,
	"./views/Merchant/List/kk.json": 83024,
	"./views/Merchant/List/pl.json": 60994,
	"./views/Merchant/List/pt.json": 76554,
	"./views/Merchant/List/ru.json": 22767,
	"./views/Merchant/List/uk.json": 4646,
	"./views/Merchant/List/zh.json": 63184,
	"./views/Merchant/New/ar.json": 38133,
	"./views/Merchant/New/cs.json": 22752,
	"./views/Merchant/New/de.json": 82801,
	"./views/Merchant/New/en.json": 34949,
	"./views/Merchant/New/es.json": 27790,
	"./views/Merchant/New/fr.json": 5190,
	"./views/Merchant/New/hi.json": 42769,
	"./views/Merchant/New/it.json": 70943,
	"./views/Merchant/New/kk.json": 11248,
	"./views/Merchant/New/pl.json": 61474,
	"./views/Merchant/New/pt.json": 74026,
	"./views/Merchant/New/ru.json": 96399,
	"./views/Merchant/New/uk.json": 78278,
	"./views/Merchant/New/zh.json": 6192,
	"./views/MultiSelect/ar.json": 62481,
	"./views/MultiSelect/cs.json": 35532,
	"./views/MultiSelect/de.json": 56861,
	"./views/MultiSelect/en.json": 54481,
	"./views/MultiSelect/es.json": 7922,
	"./views/MultiSelect/fr.json": 80618,
	"./views/MultiSelect/hi.json": 70589,
	"./views/MultiSelect/it.json": 36512,
	"./views/MultiSelect/kk.json": 69196,
	"./views/MultiSelect/pl.json": 59302,
	"./views/MultiSelect/pt.json": 35198,
	"./views/MultiSelect/ru.json": 40947,
	"./views/MultiSelect/uk.json": 86762,
	"./views/MultiSelect/zh.json": 51660,
	"./views/Notify/ar.json": 39261,
	"./views/Notify/cs.json": 53256,
	"./views/Notify/de.json": 28249,
	"./views/Notify/en.json": 70557,
	"./views/Notify/es.json": 44726,
	"./views/Notify/fr.json": 7214,
	"./views/Notify/hi.json": 12505,
	"./views/Notify/it.json": 13047,
	"./views/Notify/kk.json": 25048,
	"./views/Notify/pl.json": 24282,
	"./views/Notify/pt.json": 85938,
	"./views/Notify/ru.json": 3588,
	"./views/Notify/uk.json": 48350,
	"./views/Notify/zh.json": 4280,
	"./views/P2P/ActiveSwaps/ar.json": 94287,
	"./views/P2P/ActiveSwaps/cs.json": 58022,
	"./views/P2P/ActiveSwaps/de.json": 67047,
	"./views/P2P/ActiveSwaps/en.json": 30719,
	"./views/P2P/ActiveSwaps/es.json": 98712,
	"./views/P2P/ActiveSwaps/fr.json": 6012,
	"./views/P2P/ActiveSwaps/hi.json": 97631,
	"./views/P2P/ActiveSwaps/it.json": 77445,
	"./views/P2P/ActiveSwaps/kk.json": 40726,
	"./views/P2P/ActiveSwaps/pl.json": 13864,
	"./views/P2P/ActiveSwaps/pt.json": 79392,
	"./views/P2P/ActiveSwaps/ru.json": 41769,
	"./views/P2P/ActiveSwaps/uk.json": 77632,
	"./views/P2P/ActiveSwaps/zh.json": 37970,
	"./views/P2P/CheckCurrP2POffers/ar.json": 15860,
	"./views/P2P/CheckCurrP2POffers/cs.json": 22333,
	"./views/P2P/CheckCurrP2POffers/de.json": 65024,
	"./views/P2P/CheckCurrP2POffers/en.json": 76060,
	"./views/P2P/CheckCurrP2POffers/es.json": 6571,
	"./views/P2P/CheckCurrP2POffers/fr.json": 80007,
	"./views/P2P/CheckCurrP2POffers/hi.json": 66920,
	"./views/P2P/CheckCurrP2POffers/it.json": 31042,
	"./views/P2P/CheckCurrP2POffers/kk.json": 50650,
	"./views/P2P/CheckCurrP2POffers/pl.json": 50687,
	"./views/P2P/CheckCurrP2POffers/pt.json": 57831,
	"./views/P2P/CheckCurrP2POffers/ru.json": 67310,
	"./views/P2P/CheckCurrP2POffers/uk.json": 4019,
	"./views/P2P/CheckCurrP2POffers/zh.json": 5581,
	"./views/P2P/Edit/ar.json": 60303,
	"./views/P2P/Edit/cs.json": 38662,
	"./views/P2P/Edit/de.json": 25767,
	"./views/P2P/Edit/en.json": 1567,
	"./views/P2P/Edit/es.json": 72056,
	"./views/P2P/Edit/fr.json": 83663,
	"./views/P2P/Edit/hi.json": 29855,
	"./views/P2P/Edit/it.json": 36389,
	"./views/P2P/Edit/kk.json": 1910,
	"./views/P2P/Edit/pl.json": 9224,
	"./views/P2P/Edit/pt.json": 9824,
	"./views/P2P/Edit/ru.json": 77033,
	"./views/P2P/Edit/uk.json": 72992,
	"./views/P2P/Edit/zh.json": 63282,
	"./views/P2P/ExternalCurr/ar.json": 46930,
	"./views/P2P/ExternalCurr/cs.json": 31655,
	"./views/P2P/ExternalCurr/de.json": 85946,
	"./views/P2P/ExternalCurr/en.json": 35698,
	"./views/P2P/ExternalCurr/es.json": 1489,
	"./views/P2P/ExternalCurr/fr.json": 74745,
	"./views/P2P/ExternalCurr/hi.json": 68242,
	"./views/P2P/ExternalCurr/it.json": 17300,
	"./views/P2P/ExternalCurr/kk.json": 40839,
	"./views/P2P/ExternalCurr/pl.json": 31422,
	"./views/P2P/ExternalCurr/pt.json": 55113,
	"./views/P2P/ExternalCurr/ru.json": 20436,
	"./views/P2P/ExternalCurr/uk.json": 85305,
	"./views/P2P/ExternalCurr/zh.json": 52795,
	"./views/P2P/ExternalCurrencies/ar.json": 83699,
	"./views/P2P/ExternalCurrencies/cs.json": 56122,
	"./views/P2P/ExternalCurrencies/de.json": 62555,
	"./views/P2P/ExternalCurrencies/en.json": 20371,
	"./views/P2P/ExternalCurrencies/es.json": 22356,
	"./views/P2P/ExternalCurrencies/fr.json": 48840,
	"./views/P2P/ExternalCurrencies/hi.json": 37587,
	"./views/P2P/ExternalCurrencies/it.json": 32465,
	"./views/P2P/ExternalCurrencies/kk.json": 52346,
	"./views/P2P/ExternalCurrencies/pl.json": 33639,
	"./views/P2P/ExternalCurrencies/pt.json": 89772,
	"./views/P2P/ExternalCurrencies/ru.json": 89669,
	"./views/P2P/ExternalCurrencies/uk.json": 7548,
	"./views/P2P/ExternalCurrencies/zh.json": 99638,
	"./views/P2P/New/ar.json": 71336,
	"./views/P2P/New/cs.json": 48130,
	"./views/P2P/New/de.json": 39587,
	"./views/P2P/New/en.json": 38411,
	"./views/P2P/New/es.json": 57231,
	"./views/P2P/New/fr.json": 18480,
	"./views/P2P/New/hi.json": 87067,
	"./views/P2P/New/it.json": 93769,
	"./views/P2P/New/kk.json": 71522,
	"./views/P2P/New/pl.json": 96140,
	"./views/P2P/New/pt.json": 46164,
	"./views/P2P/New/ru.json": 10253,
	"./views/P2P/New/uk.json": 45076,
	"./views/P2P/New/zh.json": 39710,
	"./views/P2P/Offers/ar.json": 12390,
	"./views/P2P/Offers/cs.json": 19323,
	"./views/P2P/Offers/de.json": 96254,
	"./views/P2P/Offers/en.json": 18662,
	"./views/P2P/Offers/es.json": 74157,
	"./views/P2P/Offers/fr.json": 92085,
	"./views/P2P/Offers/hi.json": 42486,
	"./views/P2P/Offers/it.json": 71248,
	"./views/P2P/Offers/kk.json": 54907,
	"./views/P2P/Offers/pl.json": 88653,
	"./views/P2P/Offers/pt.json": 78293,
	"./views/P2P/Offers/ru.json": 55728,
	"./views/P2P/Offers/uk.json": 13221,
	"./views/P2P/Offers/zh.json": 51023,
	"./views/P2P/P2P/ar.json": 49707,
	"./views/P2P/P2P/cs.json": 28466,
	"./views/P2P/P2P/de.json": 48947,
	"./views/P2P/P2P/en.json": 43675,
	"./views/P2P/P2P/es.json": 80972,
	"./views/P2P/P2P/fr.json": 54528,
	"./views/P2P/P2P/hi.json": 60235,
	"./views/P2P/P2P/it.json": 20697,
	"./views/P2P/P2P/kk.json": 32242,
	"./views/P2P/P2P/pl.json": 64252,
	"./views/P2P/P2P/ru.json": 64957,
	"./views/P2P/P2P/uk.json": 87012,
	"./views/P2P/P2P/zh.json": 58670,
	"./views/P2P/P2PChat/ar.json": 79629,
	"./views/P2P/P2PChat/cs.json": 19352,
	"./views/P2P/P2PChat/de.json": 3081,
	"./views/P2P/P2PChat/en.json": 58957,
	"./views/P2P/P2PChat/es.json": 37414,
	"./views/P2P/P2PChat/fr.json": 39070,
	"./views/P2P/P2PChat/hi.json": 81225,
	"./views/P2P/P2PChat/it.json": 3047,
	"./views/P2P/P2PChat/kk.json": 29480,
	"./views/P2P/P2PChat/pl.json": 8170,
	"./views/P2P/P2PChat/pt.json": 92610,
	"./views/P2P/P2PChat/ru.json": 16263,
	"./views/P2P/P2PChat/uk.json": 77006,
	"./views/P2P/P2PChat/zh.json": 85800,
	"./views/P2P/RequestP2PArbitrage/ar.json": 20465,
	"./views/P2P/RequestP2PArbitrage/cs.json": 93516,
	"./views/P2P/RequestP2PArbitrage/de.json": 14845,
	"./views/P2P/RequestP2PArbitrage/en.json": 12465,
	"./views/P2P/RequestP2PArbitrage/es.json": 65906,
	"./views/P2P/RequestP2PArbitrage/fr.json": 38602,
	"./views/P2P/RequestP2PArbitrage/hi.json": 12221,
	"./views/P2P/RequestP2PArbitrage/it.json": 72115,
	"./views/P2P/RequestP2PArbitrage/kk.json": 27180,
	"./views/P2P/RequestP2PArbitrage/pl.json": 17286,
	"./views/P2P/RequestP2PArbitrage/pt.json": 93182,
	"./views/P2P/RequestP2PArbitrage/ru.json": 98931,
	"./views/P2P/RequestP2PArbitrage/uk.json": 44746,
	"./views/P2P/RequestP2PArbitrage/zh.json": 9644,
	"./views/P2P/RequestP2POffer/ar.json": 47538,
	"./views/P2P/RequestP2POffer/cs.json": 32263,
	"./views/P2P/RequestP2POffer/de.json": 86554,
	"./views/P2P/RequestP2POffer/en.json": 52658,
	"./views/P2P/RequestP2POffer/es.json": 18449,
	"./views/P2P/RequestP2POffer/fr.json": 75353,
	"./views/P2P/RequestP2POffer/hi.json": 85202,
	"./views/P2P/RequestP2POffer/it.json": 34260,
	"./views/P2P/RequestP2POffer/kk.json": 41447,
	"./views/P2P/RequestP2POffer/pl.json": 9649,
	"./views/P2P/RequestP2POffer/pt.json": 55721,
	"./views/P2P/RequestP2POffer/ru.json": 21044,
	"./views/P2P/RequestP2POffer/uk.json": 2265,
	"./views/P2P/RequestP2POffer/zh.json": 53403,
	"./views/P2P/SingleSwap/ar.json": 19814,
	"./views/P2P/SingleSwap/cs.json": 29755,
	"./views/P2P/SingleSwap/de.json": 56702,
	"./views/P2P/SingleSwap/en.json": 17318,
	"./views/P2P/SingleSwap/es.json": 12333,
	"./views/P2P/SingleSwap/fr.json": 26357,
	"./views/P2P/SingleSwap/hi.json": 98486,
	"./views/P2P/SingleSwap/it.json": 66896,
	"./views/P2P/SingleSwap/kk.json": 80283,
	"./views/P2P/SingleSwap/pl.json": 10477,
	"./views/P2P/SingleSwap/pt.json": 117,
	"./views/P2P/SingleSwap/ru.json": 9232,
	"./views/P2P/SingleSwap/uk.json": 51397,
	"./views/P2P/SingleSwap/zh.json": 35151,
	"./views/P2P/Swaps/ar.json": 91701,
	"./views/P2P/Swaps/cs.json": 76320,
	"./views/P2P/Swaps/de.json": 36369,
	"./views/P2P/Swaps/en.json": 88517,
	"./views/P2P/Swaps/es.json": 81358,
	"./views/P2P/Swaps/fr.json": 58758,
	"./views/P2P/Swaps/hi.json": 96337,
	"./views/P2P/Swaps/it.json": 40863,
	"./views/P2P/Swaps/kk.json": 64816,
	"./views/P2P/Swaps/pl.json": 15042,
	"./views/P2P/Swaps/pt.json": 27594,
	"./views/P2P/Swaps/ru.json": 66319,
	"./views/P2P/Swaps/uk.json": 48198,
	"./views/P2P/Swaps/zh.json": 59760,
	"./views/Pay/ar.json": 58532,
	"./views/Pay/cs.json": 4877,
	"./views/Pay/de.json": 83696,
	"./views/Pay/en.json": 75820,
	"./views/Pay/es.json": 33691,
	"./views/Pay/fr.json": 75319,
	"./views/Pay/hi.json": 87320,
	"./views/Pay/it.json": 42642,
	"./views/Pay/kk.json": 87293,
	"./views/Pay/pl.json": 29135,
	"./views/Pay/pt.json": 51447,
	"./views/Pay/ru.json": 37598,
	"./views/Pay/uk.json": 85123,
	"./views/Pay/zh.json": 56637,
	"./views/Payin/ar.json": 98821,
	"./views/Payin/cs.json": 7344,
	"./views/Payin/de.json": 78209,
	"./views/Payin/en.json": 81877,
	"./views/Payin/es.json": 6142,
	"./views/Payin/fr.json": 63062,
	"./views/Payin/hi.json": 80705,
	"./views/Payin/it.json": 22735,
	"./views/Payin/kk.json": 14144,
	"./views/Payin/pl.json": 86866,
	"./views/Payin/pt.json": 69498,
	"./views/Payin/ru.json": 68511,
	"./views/Payin/uk.json": 46070,
	"./views/Payin/zh.json": 87712,
	"./views/Pockets/ar.json": 83191,
	"./views/Pockets/cs.json": 51662,
	"./views/Pockets/de.json": 31215,
	"./views/Pockets/en.json": 69335,
	"./views/Pockets/es.json": 68320,
	"./views/Pockets/fr.json": 66404,
	"./views/Pockets/hi.json": 70823,
	"./views/Pockets/it.json": 9405,
	"./views/Pockets/kk.json": 1566,
	"./views/Pockets/pl.json": 34464,
	"./views/Pockets/pt.json": 85288,
	"./views/Pockets/ru.json": 52177,
	"./views/Pockets/uk.json": 73816,
	"./views/Pockets/zh.json": 36282,
	"./views/RateItem/ar.json": 62229,
	"./views/RateItem/cs.json": 24467,
	"./views/RateItem/de.json": 6897,
	"./views/RateItem/en.json": 59045,
	"./views/RateItem/es.json": 51886,
	"./views/RateItem/fr.json": 29286,
	"./views/RateItem/hi.json": 66865,
	"./views/RateItem/it.json": 95039,
	"./views/RateItem/kk.json": 35344,
	"./views/RateItem/pl.json": 85570,
	"./views/RateItem/pt.json": 98122,
	"./views/RateItem/ru.json": 20495,
	"./views/RateItem/uk.json": 79993,
	"./views/RateItem/zh.json": 30288,
	"./views/Return/ar.json": 93956,
	"./views/Return/cs.json": 63277,
	"./views/Return/de.json": 42096,
	"./views/Return/en.json": 32812,
	"./views/Return/es.json": 95515,
	"./views/Return/fr.json": 59159,
	"./views/Return/hi.json": 85560,
	"./views/Return/it.json": 21733,
	"./views/Return/kk.json": 86813,
	"./views/Return/pl.json": 87535,
	"./views/Return/pt.json": 84868,
	"./views/Return/ru.json": 13822,
	"./views/Return/uk.json": 58115,
	"./views/Return/zh.json": 6301,
	"./views/Safety/Antiphishing/ar.json": 59859,
	"./views/Safety/Antiphishing/cs.json": 36410,
	"./views/Safety/Antiphishing/de.json": 17883,
	"./views/Safety/Antiphishing/en.json": 39059,
	"./views/Safety/Antiphishing/es.json": 71796,
	"./views/Safety/Antiphishing/fr.json": 10280,
	"./views/Safety/Antiphishing/hi.json": 8947,
	"./views/Safety/Antiphishing/it.json": 55409,
	"./views/Safety/Antiphishing/kk.json": 32634,
	"./views/Safety/Antiphishing/pl.json": 52,
	"./views/Safety/Antiphishing/pt.json": 25036,
	"./views/Safety/Antiphishing/ru.json": 61221,
	"./views/Safety/Antiphishing/uk.json": 80668,
	"./views/Safety/Antiphishing/zh.json": 95254,
	"./views/Safety/IP/ar.json": 72608,
	"./views/Safety/IP/cs.json": 58665,
	"./views/Safety/IP/de.json": 87852,
	"./views/Safety/IP/en.json": 26776,
	"./views/Safety/IP/es.json": 56287,
	"./views/Safety/IP/fr.json": 84139,
	"./views/Safety/IP/hi.json": 74900,
	"./views/Safety/IP/it.json": 93462,
	"./views/Safety/IP/kk.json": 62441,
	"./views/Safety/IP/pl.json": 26035,
	"./views/Safety/IP/pt.json": 94523,
	"./views/Safety/IP/ru.json": 75378,
	"./views/Safety/IP/uk.json": 38647,
	"./views/Safety/IP/zh.json": 1129,
	"./views/Safety/Magic/ar.json": 78924,
	"./views/Safety/Magic/cs.json": 93826,
	"./views/Safety/Magic/de.json": 90424,
	"./views/Safety/Magic/en.json": 57860,
	"./views/Safety/Magic/es.json": 33123,
	"./views/Safety/Magic/fr.json": 15980,
	"./views/Safety/Magic/hi.json": 32832,
	"./views/Safety/Magic/it.json": 20138,
	"./views/Safety/Magic/kk.json": 79365,
	"./views/Safety/Magic/pl.json": 69191,
	"./views/Safety/Magic/pt.json": 13631,
	"./views/Safety/Magic/ru.json": 63046,
	"./views/Safety/Magic/uk.json": 21051,
	"./views/Safety/Magic/zh.json": 43301,
	"./views/Safety/Onekey/ar.json": 6070,
	"./views/Safety/Onekey/cs.json": 89080,
	"./views/Safety/Onekey/de.json": 23246,
	"./views/Safety/Onekey/en.json": 6614,
	"./views/Safety/Onekey/es.json": 67645,
	"./views/Safety/Onekey/fr.json": 20773,
	"./views/Safety/Onekey/hi.json": 99750,
	"./views/Safety/Onekey/it.json": 27744,
	"./views/Safety/Onekey/kk.json": 62923,
	"./views/Safety/Onekey/pl.json": 51357,
	"./views/Safety/Onekey/pt.json": 33669,
	"./views/Safety/Onekey/ru.json": 14528,
	"./views/Safety/Onekey/uk.json": 28117,
	"./views/Safety/Onekey/zh.json": 1503,
	"./views/Safety/Password/ar.json": 92768,
	"./views/Safety/Password/cs.json": 22569,
	"./views/Safety/Password/de.json": 47135,
	"./views/Safety/Password/en.json": 68952,
	"./views/Safety/Password/es.json": 959,
	"./views/Safety/Password/fr.json": 9963,
	"./views/Safety/Password/hi.json": 77652,
	"./views/Safety/Password/it.json": 71094,
	"./views/Safety/Password/kk.json": 26345,
	"./views/Safety/Password/pl.json": 19795,
	"./views/Safety/Password/pt.json": 48859,
	"./views/Safety/Password/ru.json": 58674,
	"./views/Safety/Password/uk.json": 47031,
	"./views/Safety/Password/zh.json": 777,
	"./views/Safety/PayPassword/ar.json": 87752,
	"./views/Safety/PayPassword/cs.json": 38833,
	"./views/Safety/PayPassword/de.json": 64116,
	"./views/Safety/PayPassword/en.json": 94544,
	"./views/Safety/PayPassword/es.json": 46759,
	"./views/Safety/PayPassword/fr.json": 76051,
	"./views/Safety/PayPassword/hi.json": 20540,
	"./views/Safety/PayPassword/it.json": 63118,
	"./views/Safety/PayPassword/kk.json": 35057,
	"./views/Safety/PayPassword/pl.json": 90699,
	"./views/Safety/PayPassword/pt.json": 55363,
	"./views/Safety/PayPassword/ru.json": 602,
	"./views/Safety/PayPassword/uk.json": 6287,
	"./views/Safety/PayPassword/zh.json": 69297,
	"./views/Safety/SecretQuestion/ar.json": 43443,
	"./views/Safety/SecretQuestion/cs.json": 32218,
	"./views/Safety/SecretQuestion/de.json": 22299,
	"./views/Safety/SecretQuestion/en.json": 80115,
	"./views/Safety/SecretQuestion/es.json": 98452,
	"./views/Safety/SecretQuestion/fr.json": 24936,
	"./views/Safety/SecretQuestion/hi.json": 13683,
	"./views/Safety/SecretQuestion/it.json": 8561,
	"./views/Safety/SecretQuestion/kk.json": 28442,
	"./views/Safety/SecretQuestion/pl.json": 32116,
	"./views/Safety/SecretQuestion/pt.json": 65868,
	"./views/Safety/SecretQuestion/ru.json": 49413,
	"./views/Safety/SecretQuestion/uk.json": 67292,
	"./views/Safety/SecretQuestion/zh.json": 59382,
	"./views/Safety/ar.json": 68956,
	"./views/Safety/cs.json": 12037,
	"./views/Safety/de.json": 25256,
	"./views/Safety/en.json": 97844,
	"./views/Safety/es.json": 48883,
	"./views/Safety/fr.json": 39567,
	"./views/Safety/hi.json": 9104,
	"./views/Safety/it.json": 4602,
	"./views/Safety/kk.json": 36821,
	"./views/Safety/pl.json": 62519,
	"./views/Safety/pt.json": 46319,
	"./views/Safety/ru.json": 52982,
	"./views/Safety/uk.json": 79083,
	"./views/Safety/zh.json": 70709,
	"./views/ShowInfoVA/ar.json": 8978,
	"./views/ShowInfoVA/cs.json": 30887,
	"./views/ShowInfoVA/de.json": 42330,
	"./views/ShowInfoVA/en.json": 92082,
	"./views/ShowInfoVA/es.json": 63537,
	"./views/ShowInfoVA/fr.json": 81145,
	"./views/ShowInfoVA/hi.json": 17714,
	"./views/ShowInfoVA/it.json": 27028,
	"./views/ShowInfoVA/kk.json": 29287,
	"./views/ShowInfoVA/pl.json": 40830,
	"./views/ShowInfoVA/pt.json": 74633,
	"./views/ShowInfoVA/ru.json": 30164,
	"./views/ShowInfoVA/uk.json": 91705,
	"./views/ShowInfoVA/zh.json": 38139,
	"./views/Stock/CurrTransfer/ar.json": 97466,
	"./views/Stock/CurrTransfer/cs.json": 86767,
	"./views/Stock/CurrTransfer/de.json": 97378,
	"./views/Stock/CurrTransfer/en.json": 67402,
	"./views/Stock/CurrTransfer/es.json": 96921,
	"./views/Stock/CurrTransfer/fr.json": 17313,
	"./views/Stock/CurrTransfer/hi.json": 29882,
	"./views/Stock/CurrTransfer/it.json": 41068,
	"./views/Stock/CurrTransfer/kk.json": 90543,
	"./views/Stock/CurrTransfer/pl.json": 9321,
	"./views/Stock/CurrTransfer/pt.json": 53137,
	"./views/Stock/CurrTransfer/ru.json": 49820,
	"./views/Stock/CurrTransfer/uk.json": 35121,
	"./views/Stock/CurrTransfer/zh.json": 1475,
	"./views/Stock/Offers/ar.json": 86746,
	"./views/Stock/Offers/cs.json": 9839,
	"./views/Stock/Offers/de.json": 58370,
	"./views/Stock/Offers/en.json": 78698,
	"./views/Stock/Offers/es.json": 49337,
	"./views/Stock/Offers/fr.json": 6593,
	"./views/Stock/Offers/hi.json": 76634,
	"./views/Stock/Offers/it.json": 64684,
	"./views/Stock/Offers/kk.json": 13615,
	"./views/Stock/Offers/pl.json": 98601,
	"./views/Stock/Offers/pt.json": 48081,
	"./views/Stock/Offers/ru.json": 6908,
	"./views/Stock/Offers/uk.json": 42385,
	"./views/Stock/Offers/zh.json": 34147,
	"./views/Stock/OrderList/ar.json": 79181,
	"./views/Stock/OrderList/cs.json": 50808,
	"./views/Stock/OrderList/de.json": 90185,
	"./views/Stock/OrderList/en.json": 12429,
	"./views/Stock/OrderList/es.json": 17414,
	"./views/Stock/OrderList/fr.json": 47358,
	"./views/Stock/OrderList/hi.json": 24585,
	"./views/Stock/OrderList/it.json": 2279,
	"./views/Stock/OrderList/kk.json": 89192,
	"./views/Stock/OrderList/pl.json": 25354,
	"./views/Stock/OrderList/pt.json": 15138,
	"./views/Stock/OrderList/ru.json": 15495,
	"./views/Stock/OrderList/uk.json": 51438,
	"./views/Stock/OrderList/zh.json": 2984,
	"./views/Stock/StockMarket/ar.json": 32807,
	"./views/Stock/StockMarket/cs.json": 7518,
	"./views/Stock/StockMarket/de.json": 26751,
	"./views/Stock/StockMarket/en.json": 99559,
	"./views/Stock/StockMarket/es.json": 32016,
	"./views/Stock/StockMarket/fr.json": 36532,
	"./views/Stock/StockMarket/hi.json": 57047,
	"./views/Stock/StockMarket/it.json": 9389,
	"./views/Stock/StockMarket/kk.json": 68238,
	"./views/Stock/StockMarket/pl.json": 19984,
	"./views/Stock/StockMarket/pt.json": 67224,
	"./views/Stock/StockMarket/ru.json": 129,
	"./views/Stock/StockMarket/uk.json": 5992,
	"./views/Stock/StockMarket/zh.json": 62826,
	"./views/Support/ar.json": 29987,
	"./views/Support/cs.json": 61578,
	"./views/Support/de.json": 52440,
	"./views/Support/en.json": 17315,
	"./views/Support/es.json": 88132,
	"./views/Support/fr.json": 54712,
	"./views/Support/hi.json": 59875,
	"./views/Support/it.json": 84577,
	"./views/Support/kk.json": 17226,
	"./views/Support/pl.json": 97188,
	"./views/Support/pt.json": 41468,
	"./views/Support/ru.json": 87093,
	"./views/Support/uk.json": 93996,
	"./views/Support/zh.json": 69094,
	"./views/SupportNew/ar.json": 55411,
	"./views/SupportNew/cs.json": 15738,
	"./views/SupportNew/de.json": 39739,
	"./views/SupportNew/en.json": 72435,
	"./views/SupportNew/es.json": 5044,
	"./views/SupportNew/fr.json": 50984,
	"./views/SupportNew/hi.json": 45619,
	"./views/SupportNew/it.json": 3985,
	"./views/SupportNew/kk.json": 11962,
	"./views/SupportNew/pl.json": 6580,
	"./views/SupportNew/pt.json": 91916,
	"./views/SupportNew/ru.json": 43154,
	"./views/SupportNew/uk.json": 66940,
	"./views/SupportNew/zh.json": 40406,
	"./views/Templates/ar.json": 85543,
	"./views/Templates/cs.json": 52798,
	"./views/Templates/de.json": 67583,
	"./views/Templates/en.json": 6215,
	"./views/Templates/es.json": 54000,
	"./views/Templates/fr.json": 116,
	"./views/Templates/hi.json": 6231,
	"./views/Templates/it.json": 62125,
	"./views/Templates/kk.json": 77902,
	"./views/Templates/pl.json": 67760,
	"./views/Templates/pt.json": 8056,
	"./views/Templates/ru.json": 92385,
	"./views/Templates/uk.json": 20104,
	"./views/Templates/zh.json": 12554,
	"./views/Transfer/ar.json": 46071,
	"./views/Transfer/cs.json": 44974,
	"./views/Transfer/de.json": 85007,
	"./views/Transfer/en.json": 64247,
	"./views/Transfer/es.json": 75008,
	"./views/Transfer/fr.json": 80868,
	"./views/Transfer/hi.json": 8583,
	"./views/Transfer/it.json": 38109,
	"./views/Transfer/kk.json": 73182,
	"./views/Transfer/pl.json": 93920,
	"./views/Transfer/pt.json": 66472,
	"./views/Transfer/ru.json": 57585,
	"./views/Transfer/uk.json": 2520,
	"./views/Transfer/zh.json": 64986,
	"./views/TransferSelf/ar.json": 57345,
	"./views/TransferSelf/cs.json": 36380,
	"./views/TransferSelf/de.json": 48941,
	"./views/TransferSelf/en.json": 63617,
	"./views/TransferSelf/es.json": 4898,
	"./views/TransferSelf/fr.json": 23098,
	"./views/TransferSelf/hi.json": 32045,
	"./views/TransferSelf/it.json": 26243,
	"./views/TransferSelf/kk.json": 40156,
	"./views/TransferSelf/pl.json": 67222,
	"./views/TransferSelf/pt.json": 46318,
	"./views/TransferSelf/ru.json": 39459,
	"./views/TransferSelf/uk.json": 84954,
	"./views/TransferSelf/zh.json": 39548,
	"./views/Unexpected/ar.json": 33287,
	"./views/Unexpected/cs.json": 7998,
	"./views/Unexpected/de.json": 43583,
	"./views/Unexpected/en.json": 16391,
	"./views/Unexpected/es.json": 32496,
	"./views/Unexpected/fr.json": 37012,
	"./views/Unexpected/hi.json": 57527,
	"./views/Unexpected/it.json": 32250,
	"./views/Unexpected/kk.json": 85070,
	"./views/Unexpected/pl.json": 20464,
	"./views/Unexpected/pt.json": 67704,
	"./views/Unexpected/ru.json": 16961,
	"./views/Unexpected/uk.json": 22824,
	"./views/Unexpected/zh.json": 79658,
	"./views/VA/CodeVa/ar.json": 2724,
	"./views/VA/CodeVa/cs.json": 72045,
	"./views/VA/CodeVa/de.json": 50864,
	"./views/VA/CodeVa/en.json": 57932,
	"./views/VA/CodeVa/es.json": 20635,
	"./views/VA/CodeVa/fr.json": 84279,
	"./views/VA/CodeVa/hi.json": 94328,
	"./views/VA/CodeVa/it.json": 52882,
	"./views/VA/CodeVa/kk.json": 11933,
	"./views/VA/CodeVa/pl.json": 96303,
	"./views/VA/CodeVa/pt.json": 71255,
	"./views/VA/CodeVa/ru.json": 38942,
	"./views/VA/CodeVa/uk.json": 83235,
	"./views/VA/CodeVa/zh.json": 15069,
	"./views/VA/ListVa/ar.json": 81183,
	"./views/VA/ListVa/cs.json": 96310,
	"./views/VA/ListVa/de.json": 99607,
	"./views/VA/ListVa/en.json": 49071,
	"./views/VA/ListVa/es.json": 29352,
	"./views/VA/ListVa/fr.json": 38924,
	"./views/VA/ListVa/hi.json": 4207,
	"./views/VA/ListVa/it.json": 42133,
	"./views/VA/ListVa/kk.json": 29702,
	"./views/VA/ListVa/pl.json": 85880,
	"./views/VA/ListVa/pt.json": 8912,
	"./views/VA/ListVa/ru.json": 78649,
	"./views/VA/ListVa/uk.json": 8080,
	"./views/VA/ListVa/zh.json": 76194,
	"./views/VA/NewVa/ar.json": 49017,
	"./views/VA/NewVa/cs.json": 52436,
	"./views/VA/NewVa/de.json": 57445,
	"./views/VA/NewVa/en.json": 36265,
	"./views/VA/NewVa/es.json": 63130,
	"./views/VA/NewVa/fr.json": 94898,
	"./views/VA/NewVa/hi.json": 15717,
	"./views/VA/NewVa/it.json": 61675,
	"./views/VA/NewVa/kk.json": 67188,
	"./views/VA/NewVa/pl.json": 65265,
	"./views/VA/NewVa/pt.json": 42214,
	"./views/VA/NewVa/ru.json": 26523,
	"./views/VA/NewVa/uk.json": 71842,
	"./views/VA/NewVa/zh.json": 6900,
	"./views/offers/ar.json": 9499,
	"./views/offers/cs.json": 67650,
	"./views/offers/de.json": 20963,
	"./views/offers/en.json": 72107,
	"./views/offers/es.json": 41596,
	"./views/offers/fr.json": 99536,
	"./views/offers/hi.json": 47611,
	"./views/offers/it.json": 60425,
	"./views/offers/kk.json": 26178,
	"./views/offers/pl.json": 7948,
	"./views/offers/pt.json": 22612,
	"./views/offers/ru.json": 87021,
	"./views/offers/uk.json": 94324,
	"./views/offers/zh.json": 69502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89628;